// export default {
//   // 职业（工种）
//   zhiyegongzhong:[
//     {label:'企业管理人员',value:'1000000'},
//     {label:'部门经理',value:'1050000'},
//     {label:'其他企业管理人员',value:'1050100'},
//     {label:'专业、技术人员',value:'1059900'},
//     {label:'科研人员',value:'2000000'},
//     {label:'科研人员',value:'2010000'},
//     {label:'工程技术人员',value:'2019900'},
//     {label:'地质勘探工程技术人员',value:'2020000'},
//     {label:'测绘工程技术人员',value:'2020100'},
//     {label:'矿山工程技术人员',value:'2020200'},
//     {label:'石油工程技术人员',value:'2020300'},
//     {label:'冶金工程技术人员',value:'2020400'},
//     {label:'化工工程技术人员',value:'2020500'},
//     {label:'机械工程技术人员',value:'2020600'},
//     {label:'兵器航空航天工程技术人员',value:'2020700'},
//     {label:'电子工程技术人员',value:'2020800'},
//     {label:'通信工程技术人员',value:'2021100'},
//     {label:'计算机工程技术人员',value:'2021200'},
//     {label:'电气工程技术人员',value:'2021300'},
//     {label:'电力工程技术人员',value:'2021400'},
//     {label:'邮政工程技术人员',value:'2021500'},
//     {label:'广播影视工程技术人员',value:'2021600'},
//     {label:'交通工程技术人员',value:'2021700'},
//     {label:'民用航空工程技术人员',value:'2021800'},
//     {label:'铁路工程技术人员',value:'2021900'},
//     {label:'建筑工程技术人员',value:'2022000'},
//     {label:'建材工程技术人员',value:'2022100'},
//     {label:'家具设计、林业工程技术人员',value:'2022200'},
//     {label:'水利工程技术人员',value:'2022300'},
//     {label:'海洋工程技术人员',value:'2022400'},
//     {label:'水产工程技术人员',value:'2022500'},
//     {label:'纺织工程技术人员',value:'2022600'},
//     {label:'食品工程技术人员',value:'2022700'},
//     {label:'气象工程技术人员',value:'2022800'},
//     {label:'地震工程技术人员',value:'2022900'},
//     {label:'环境保护工程技术人员',value:'2023000'},
//     {label:'安全工程技术人员',value:'2023100'},
//     {label:'标准化、计量、质量工程技术人员',value:'2023200'},
//     {label:'工业管理工程技术人员',value:'2023300'},
//     {label:'生物工程技术人员',value:'2023400'},
//     {label:'其他工程技术人员',value:'2023500'},
//     {label:'农业技术人员',value:'2029900'},
//     {label:'土壤肥料技术人员',value:'2030000'},
//     {label:'植物保护技术人员',value:'2030100'},
//     {label:'园艺技术人员',value:'2030200'},
//     {label:'作物遗传育种栽培技术人员',value:'2030300'},
//     {label:'兽医兽药技术人员',value:'2030400'},
//     {label:'畜牧与草业技术人员',value:'2030500'},
//     {label:'其他农业技术人员',value:'2030600'},
//     {label:'飞机船舶技术人员',value:'2039900'},
//     {label:'船舶指挥引航人员',value:'2040000'},
//     {label:'其他飞机船舶技术人员',value:'2040200'},
//     {label:'卫生专业技术人员',value:'2049900'},
//     {label:'西医',value:'2050000'},
//     {label:'中医',value:'2050100'},
//     {label:'公共卫生医师',value:'2050200'},
//     {label:'药剂师',value:'2050500'},
//     {label:'医疗技术人员',value:'2050600'},
//     {label:'护士',value:'2050700'},
//     {label:'其他卫生专业技术人员',value:'2050800'},
//     {label:'经济业务人员',value:'2059900'},
//     {label:'经济计划人员',value:'2060000'},
//     {label:'统计师',value:'2060100'},
//     {label:'财会人员',value:'2060200'},
//     {label:'审计师',value:'2060300'},
//     {label:'国际商务人员',value:'2060400'},
//     {label:'房地产业务人员',value:'2060500'},
//     {label:'其他经济业务人员',value:'2060600'},
//     {label:'金融业务人员',value:'2069900'},
//     {label:'银行业务人员',value:'2070000'},
//     {label:'保险业务人员',value:'2070100'},
//     {label:'证券业务人员',value:'2070200'},
//     {label:'其他金融业务人员',value:'2070300'},
//     {label:'法律专业人员',value:'2079900'},
//     {label:'律师',value:'2080000'},
//     {label:'其他法律专业人员',value:'2080300'},
//     {label:'教学人员',value:'2089900'},
//     {label:'高等教育教师',value:'2090000'},
//     {label:'中等职业教育教师',value:'2090100'},
//     {label:'中学教师',value:'2090200'},
//     {label:'小学教师',value:'2090300'},
//     {label:'幼儿教师',value:'2090400'},
//     {label:'特殊教育教师',value:'2090500'},
//     {label:'其他教学人员',value:'2090600'},
//     {label:'文学艺术工作者',value:'2099900'},
//     {label:'文艺创作和评论人员',value:'2100000'},
//     {label:'编导和音乐指挥人员',value:'2100100'},
//     {label:'演员',value:'2100200'},
//     {label:'乐器演奏员',value:'2100300'},
//     {label:'影视制作及舞台专业人员',value:'2100400'},
//     {label:'美术专业人员',value:'2100500'},
//     {label:'工美装饰服装广告设计人员',value:'2100600'},
//     {label:'装璜美术设计人员',value:'2100700'},
//     {label:'服装设计师',value:'2100704'},
//     {label:'室内装饰设计人员',value:'2100705'},
//     {label:'广告设计人员',value:'2100706'},
//     {label:'其他文学艺术工作者',value:'2100708'},
//     {label:'体育工作者',value:'2109900'},
//     {label:'体育工作者',value:'2110000'},
//     {label:'新闻出版文化工作者',value:'2110100'},
//     {label:'记者',value:'2120000'},
//     {label:'编辑',value:'2120100'},
//     {label:'播音员及节目主持人',value:'2120200'},
//     {label:'翻译',value:'2120400'},
//     {label:'图书资料档案业务人员',value:'2120500'},
//     {label:'其他新闻出版、文化工作者',value:'2120600'},
//     {label:'办事人员',value:'2129900'},
//     {label:'行政办公人员',value:'3000000'},
//     {label:'行政业务人员',value:'3010000'},
//     {label:'秘书、打字员',value:'3010100'},
//     {label:'其他行政办公人员',value:'3010200'},
//     {label:'安全保卫和消防人员',value:'3019900'},
//     {label:'治安保卫人员',value:'3020000'},
//     {label:'其他安全保卫消防人员',value:'3020200'},
//     {label:'邮政电信业务人员',value:'3029900'},
//     {label:'邮政业务人员',value:'3030000'},
//     {label:'电信业务人员、话务员',value:'3030100'},
//     {label:'电信通信传输业务人员',value:'3030200'},
//     {label:'其他邮政电信业务人员',value:'3030300'},
//     {label:'商业、服务业人员',value:'3039900'},
//     {label:'购销人员',value:'4000000'},
//     {label:'营业人员、收银员',value:'4010000'},
//     {label:'推销展销人员',value:'4010100'},
//     {label:'采购人员',value:'4010200'},
//     {label:'废旧物资回收利用人员',value:'4010300'},
//     {label:'商品监督和市场管理员',value:'4010500'},
//     {label:'医药商品购销员',value:'4010700'},
//     {label:'其他购销人员',value:'4013000'},
//     {label:'仓储人员',value:'4019900'},
//     {label:'保管人员',value:'4020000'},
//     {label:'储运人员',value:'4020100'},
//     {label:'其他仓储人员',value:'4020200'},
//     {label:'餐饮服务人员',value:'4029900'},
//     {label:'中餐烹饪人员',value:'4030000'},
//     {label:'西餐烹饪人员',value:'4030100'},
//     {label:'调酒和茶艺人员',value:'4030200'},
//     {label:'餐厅服务员、厨工',value:'4030300'},
//     {label:'其他餐饮服务人员',value:'4030500'},
//     {label:'饭店、旅游娱乐服务员',value:'4039900'},
//     {label:'饭店服务人员',value:'4040000'},
//     {label:'旅游游览场所服务员',value:'4040100'},
//     {label:'健身娱乐场所服务员',value:'4040200'},
//     {label:'其他旅游健身娱乐服务人员',value:'4040300'},
//     {label:'运输服务人员',value:'4049900'},
//     {label:'公路运输服务人员',value:'4050000'},
//     {label:'铁路运输服务人员',value:'4050100'},
//     {label:'航空运输服务人员',value:'4050200'},
//     {label:'水上运输服务人员',value:'4050300'},
//     {label:'其他运输服务人员',value:'4050400'},
//     {label:'医疗卫生辅助服务人员',value:'4059900'},
//     {label:'护理人员',value:'4060000'},
//     {label:'其他医疗卫生辅助服务人员',value:'4060100'},
//     {label:'社会服务人员',value:'4069900'},
//     {label:'社会中介服务人员',value:'4070000'},
//     {label:'物业管理人员',value:'4070100'},
//     {label:'供水供热人员、锅炉工',value:'4070200'},
//     {label:'美发美容人员',value:'4070300'},
//     {label:'摄影服务人员',value:'4070400'},
//     {label:'验光配镜人员',value:'4070500'},
//     {label:'洗染、织补人员',value:'4070600'},
//     {label:'浴池服务人员',value:'4070700'},
//     {label:'家用机电产品维修人员',value:'4070800'},
//     {label:'办公设备维修人员',value:'4071000'},
//     {label:'保育、家庭服务员',value:'4071100'},
//     {label:'清洁工',value:'4071200'},
//     {label:'家庭教师',value:'4071300'},
//     {label:'电梯工',value:'4073000'},
//     {label:'其他社会服务人员',value:'4073100'},
//     {label:'农林牧渔水利生产人员',value:'4079900'},
//     {label:'种植业生产人员',value:'5000000'},
//     {label:'大田作物生产人员',value:'5010000'},
//     {label:'农业实验人员',value:'5010100'},
//     {label:'园艺作物生产人员',value:'5010200'},
//     {label:'中药材生产人员',value:'5010300'},
//     {label:'农副林特产品加工工',value:'5010500'},
//     {label:'其他种植业生产人员',value:'5010600'},
//     {label:'林业及动植物保护人员',value:'5019900'},
//     {label:'木材采运人员',value:'5020000'},
//     {label:'其他林业及野生动植物保护人员',value:'5020400'},
//     {label:'畜牧业生产人员',value:'5029900'},
//     {label:'畜牧业生产人员',value:'5030000'},
//     {label:'渔业生产人员',value:'5039900'},
//     {label:'水产养殖人员',value:'5040000'},
//     {label:'水产捕捞及有关人员',value:'5040100'},
//     {label:'水产品加工工',value:'5040200'},
//     {label:'其他渔业生产人员',value:'5040300'},
//     {label:'水利设施管理养护人员',value:'5049900'},
//     {label:'水利设施管理养护人员',value:'5050000'},
//     {label:'农林机械操作和能源开发人员',value:'5059900'},
//     {label:'农林机械操作和能源开发人员',value:'5090000'},
//     {label:'生产运输工人',value:'5090100'},
//     {label:'勘测及矿物开采工',value:'6000000'},
//     {label:'地质勘查人员',value:'6010000'},
//     {label:'测绘人员',value:'6010100'},
//     {label:'矿物开采工',value:'6010200'},
//     {label:'矿物处理工',value:'6010300'},
//     {label:'钻井人员',value:'6010400'},
//     {label:'石油、天然气开采人员',value:'6010500'},
//     {label:'盐业生产人员',value:'6010600'},
//     {label:'其他勘测及矿物开采工',value:'6010700'},
//     {label:'金属冶炼轧制工',value:'6019900'},
//     {label:'金属冶炼工',value:'6020000'},
//     {label:'金属轧制工',value:'6020100'},
//     {label:'其他金属冶炼、轧制工',value:'6020800'},
//     {label:'化工产品生产工',value:'6029900'},
//     {label:'化工产品生产工',value:'6030000'},
//     {label:'机械制造加工工',value:'6039900'},
//     {label:'机械冷加工工',value:'6040000'},
//     {label:'车工',value:'6040100'},
//     {label:'铣工',value:'6040101'},
//     {label:'刨插工',value:'6040102'},
//     {label:'磨工',value:'6040103'},
//     {label:'镗工',value:'6040104'},
//     {label:'钻床工',value:'6040105'},
//     {label:'加工中心操作工',value:'6040106'},
//     {label:'制齿工',value:'6040108'},
//     {label:'机械热加工工',value:'6040109'},
//     {label:'铸造工',value:'6040200'},
//     {label:'锻造工',value:'6040201'},
//     {label:'冲压工',value:'6040202'},
//     {label:'焊工',value:'6040203'},
//     {label:'金属热处理工',value:'6040205'},
//     {label:'特种加工设备操作工',value:'6040206'},
//     {label:'冷作钣金加工工',value:'6040300'},
//     {label:'工件表面处理加工工',value:'6040400'},
//     {label:'磨料磨具制造加工人员',value:'6040500'},
//     {label:'其他机械制造加工工',value:'6040600'},
//     {label:'机电产品装配工',value:'6049900'},
//     {label:'机械设备装配工',value:'6050000'},
//     {label:'电气电子设备装配工',value:'6050200'},
//     {label:'仪器仪表装配工',value:'6050400'},
//     {label:'运输车辆装配工',value:'6050600'},
//     {label:'其他机电产品装配工',value:'6050700'},
//     {label:'机械设备修理工',value:'6059900'},
//     {label:'机械设备维修工',value:'6060000'},
//     {label:'仪器仪表修理工',value:'6060100'},
//     {label:'其他机械设备修理工',value:'6060200'},
//     {label:'电力设备装运检修工',value:'6069900'},
//     {label:'电力设备安装工',value:'6070000'},
//     {label:'专业电力设备检修工',value:'6070100'},
//     {label:'普通电力设备检修工、电工',value:'6070400'},
//     {label:'其他电力设备装运、检修及供电工',value:'6070600'},
//     {label:'电子元器件制造装调工',value:'6079900'},
//     {label:'电子元件、器件制造工',value:'6080000'},
//     {label:'电子设备装配调试工',value:'6080100'},
//     {label:'电子产品维修工',value:'6080400'},
//     {label:'其他电子元器件与电子设备制造、装调维修工',value:'6080500'},
//     {label:'橡胶塑料制品生产工',value:'6089900'},
//     {label:'橡胶制品生产工',value:'6090000'},
//     {label:'塑料制品加工工',value:'6090100'},
//     {label:'其他橡胶和塑料制品生产工',value:'6090200'},
//     {label:'纺织针织印染工',value:'6099900'},
//     {label:'纤维预处理人员',value:'6100000'},
//     {label:'纺纱人员',value:'6100100'},
//     {label:'织造人员',value:'6100200'},
//     {label:'针织人员',value:'6100300'},
//     {label:'印染人员',value:'6100400'},
//     {label:'纺织、针织、印染工',value:'6100500'},
//     {label:'裁剪缝纫毛皮革制作工',value:'6109900'},
//     {label:'裁剪缝纫工',value:'6110000'},
//     {label:'鞋帽制作工',value:'6110100'},
//     {label:'皮革、毛皮加工工',value:'6110200'},
//     {label:'缝纫制品再加工人员',value:'6110300'},
//     {label:'其他裁剪缝纫和毛皮革制作工',value:'6110400'},
//     {label:'粮油食品饮料生产工',value:'6119900'},
//     {label:'粮油食品饮料生产加工及饲料加工工',value:'6120000'},
//     {label:'烟草制品加工工',value:'6129900'},
//     {label:'烟草制品加工工',value:'6130000'},
//     {label:'药品生产制造工',value:'6139900'},
//     {label:'药品生产制造工',value:'6140000'},
//     {label:'木材人造板生产制作工',value:'6149900'},
//     {label:'木材加工制作工',value:'6150000'},
//     {label:'其他木材加工、人造板生产及木制品制作工',value:'6150100'},
//     {label:'制浆造纸纸制品生产工',value:'6159900'},
//     {label:'纸制品制作工',value:'6160000'},
//     {label:'其他制浆、造纸和纸制品生产加工工',value:'6160300'},
//     {label:'建筑材料生产加工工',value:'6169900'},
//     {label:'建筑材料生产加工工',value:'6170000'},
//     {label:'玻璃陶瓷搪瓷生产工',value:'6179900'},
//     {label:'玻璃陶瓷搪瓷生产加工工',value:'6180000'},
//     {label:'广播影视品制作播放人员',value:'6189900'},
//     {label:'广播影视设备操作人员',value:'6190000'},
//     {label:'其他广播影视品制作播放及文物保护人员',value:'6190300'},
//     {label:'制版印刷人员',value:'6199900'},
//     {label:'制版印刷人员',value:'6200000'},
//     {label:'工艺、美术品制作人员',value:'6209900'},
//     {label:'工艺、美术品制作人员',value:'6210000'},
//     {label:'文体用品乐器制作人员',value:'6219900'},
//     {label:'文体用品乐器制作人员',value:'6220000'},
//     {label:'建筑和工程施工人员',value:'6229900'},
//     {label:'土石方施工人员',value:'6230000'},
//     {label:'砌筑工',value:'6230100'},
//     {label:'混凝土工',value:'6230200'},
//     {label:'钢筋工',value:'6230300'},
//     {label:'架子工',value:'6230400'},
//     {label:'工程防水工',value:'6230500'},
//     {label:'装饰、装修、油漆工',value:'6230600'},
//     {label:'筑路、养护、维修人员',value:'6230700'},
//     {label:'机械电气工程设备安装工、管工',value:'6230900'},
//     {label:'电工',value:'6231000'},
//     {label:'木工',value:'6231100'},
//     {label:'其他工程施工人员',value:'6233000'},
//     {label:'驾驶员和运输工人',value:'6239900'},
//     {label:'机动车驾驶员',value:'6240000'},
//     {label:'铁路、地铁运输设备操作及有关人员',value:'6240100'},
//     {label:'船舶水手',value:'6240200'},
//     {label:'起重装卸机械操作工',value:'6240400'},
//     {label:'其他运输设备操作人员',value:'6240500'},
//     {label:'环境监测废物处理人员',value:'6249900'},
//     {label:'环境监测废物处理人员',value:'6250000'},
//     {label:'检验、计量人员',value:'6259900'},
//     {label:'检验、计量人员',value:'6260000'},
//     {label:'普通工人',value:'6269900'},
//     {label:'普通工',value:'6270000'},
//     {label:'  }',value:'6279900'},
//   ],
//   // 国家职业等级
//   guojiazhiyedengji:[
//     {label:'职业资格一级（高级技师）',value:'1'},
//     {label:'职业资格二级（技师）',value:'2'},
//     {label:'职业资格三级（高级）',value:'3'},
//     {label:'职业资格四级（中级）',value:'4'},
//     {label:'职业资格五级（初级）',value:'5'},
//     {label:'其他',value:'9'},
//     {label:'未填写',value:'0'},
//   ],
//   // 所学专业
//   suoxuezhuanye:[
//     {label:'哲学',value:'010000'},
//     {label:'哲学类',value:'010100'},
//     {label:'马克思主义理论类',value:'010200'},
//     {label:'经济学',value:'020000'},
//     {label:'经济学类',value:'020100'},
//     {label:'工商管理类',value:'0020200'},
//     {label:'法学',value:'030000'},
//     {label:'法学类',value:'030100'},
//     {label:'社会学类',value:'030200'},
//     {label:'政治学类',value:'030300'},
//     {label:'公安学类',value:'030400'},
//     {label:'教育学',value:'040000'},
//     {label:'教育学类',value:'040100'},
//     {label:'思想政治教育类',value:'040200'},
//     {label:'体育学类',value:'040300'},
//     {label:'职业技术教育类',value:'040400'},
//     {label:'文学',value:'050000'},
//     {label:'中国语言文学类',value:'050100'},
//     {label:'外国语言文学类',value:'050200'},
//     {label:'新闻学类',value:'050300'},
//     {label:'艺术类(一)',value:'050400'},
//     {label:'艺术类(二)',value:'050500'},
//     {label:'历史学',value:'060000'},
//     {label:'历史学类',value:'060100'},
//     {label:'图书信息档案学类',value:'060200'},
//     {label:'理学',value:'070000'},
//     {label:'数学类',value:'070100'},
//     {label:'物理学类',value:'070200'},
//     {label:'化学类',value:'070300'},
//     {label:'生物科学类',value:'070400'},
//     {label:'天文学类',value:'070500'},
//     {label:'地质学类',value:'070600'},
//     {label:'地理科学类',value:'070700'},
//     {label:'地球物理学类',value:'070800'},
//     {label:'大气科学类',value:'070900'},
//     {label:'海洋科学类',value:'071000'},
//     {label:'力学类',value:'071100'},
//     {label:'信息与电子科学类',value:'071200'},
//     {label:'材料科学类',value:'071300'},
//     {label:'环境科学类',value:'071400'},
//     {label:'心理学类',value:'071500'},
//     {label:'科技信息与管理类',value:'071600'},
//     {label:'工学',value:'080000'},
//     {label:'地矿类',value:'080100'},
//     {label:'材料类',value:'080200'},
//     {label:'机械类',value:'080300'},
//     {label:'仪器仪表类',value:'080400'},
//     {label:'热能核能类',value:'080500'},
//     {label:'电工类',value:'080600'},
//     {label:'电子与信息类',value:'080700'},
//     {label:'土建类',value:'080800'},
//     {label:'水利类',value:'080900'},
//     {label:'测绘类',value:'081000'},
//     {label:'环境类',value:'081100'},
//     {label:'化工与制药类',value:'081200'},
//     {label:'轻工粮食食品类',value:'081300'},
//     {label:'农业工程类',value:'081400'},
//     {label:'林业工程类',value:'081500'},
//     {label:'纺织类',value:'081600'},
//     {label:'交通运输类',value:'081700'},
//     {label:'航空航天类',value:'081800'},
//     {label:'兵器类',value:'081900'},
//     {label:'公安技术类',value:'082000'},
//     {label:'工程力学类',value:'082100'},
//     {label:'管理工程类',value:'082200'},
//     {label:'农学',value:'090000'},
//     {label:'植物生产类',value:'090100'},
//     {label:'森林资源类',value:'090200'},
//     {label:'环境保护类',value:'090300'},
//     {label:'动物生产与兽医类',value:'090400'},
//     {label:'水产类',value:'090500'},
//     {label:'管理类',value:'090600'},
//     {label:'农业推广类',value:'090700'},
//     {label:'医学',value:'100000'},
//     {label:'基础医学类',value:'100100'},
//     {label:'预防医学类',value:'100200'},
//     {label:'临床医学与医学技术类',value:'100300'},
//     {label:'口腔医学类',value:'100400'},
//     {label:'中医学类',value:'100500'},
//     {label:'法医学类',value:'100600'},
//     {label:'护理学类',value:'100700'},
//     {label:'药学类',value:'100800'},
//     {label:'管理类',value:'100900'},
//     {label:'军事学',value:'110000'},
//     {label:'其他学科',value:'990000'},
//     {label:'未填写',value:'000000'},
//   ],
//   // 学历
//   xueli:[
//     {label:'博士研究生',value:'11'},
//     {label:'硕士研究生',value:'14'},
//     {label:'大学本科',value:'21'},
//     {label:'大学专科',value:'31'},
//     {label:'中等专科',value:'41'},
//     {label:'职业高中',value:'44'},
//     {label:'技工学校',value:'47'},
//     {label:'普通高中',value:'61'},
//     {label:'初中',value:'71'},
//     {label:'小学',value:'81'},
//     {label:'其他',value:'90'},
//     {label:'无要求',value:'00'},
//   ],
//   // 职称
//   zhicheng:[
//     {label:'高等学校教师',value:'010'},
//     {label:'教授',value:'011'},
//     {label:'副教授',value:'012'},
//     {label:'讲师（高校）',value:'013'},
//     {label:'助教（高校）',value:'014'},
//     {label:'中等专业学校教师',value:'020'},
//     {label:'高级讲师（中专）',value:'022'},
//     {label:'讲师（中专）',value:'023'},
//     {label:'助理讲师（中专）',value:'024'},
//     {label:'教员（中专）',value:'025'},
//     {label:'技工学校教师（文化理论）',value:'030'},
//     {label:'高级讲师（技校）',value:'032'},
//     {label:'讲师（技校）',value:'033'},
//     {label:'助理讲师（技校）',value:'034'},
//     {label:'教员（技校）',value:'035'},
//     {label:'技工学校教师（实习指导）',value:'040'},
//     {label:'高级实习指导教师',value:'042'},
//     {label:'一级实习指导教师',value:'043'},
//     {label:'二级实习指导教师',value:'044'},
//     {label:'三级实习指导教师',value:'045'},
//     {label:'中学教师',value:'050'},
//     {label:'高级教师（中学）',value:'052'},
//     {label:'一级教师（中学）',value:'053'},
//     {label:'二级教师（中学）',value:'054'},
//     {label:'三级教师（中学）',value:'055'},
//     {label:'实验技术人员',value:'070'},
//     {label:'高级实验师',value:'072'},
//     {label:'实验师',value:'073'},
//     {label:'助理实验师',value:'074'},
//     {label:'实验员',value:'075'},
//     {label:'工程技术人员',value:'080'},
//     {label:'高级工程师',value:'082'},
//     {label:'工程师',value:'083'},
//     {label:'助理工程师',value:'084'},
//     {label:'技术员',value:'085'},
//     {label:'农业技术人员（农艺）',value:'090'},
//     {label:'农业技术推广研究员（农艺）',value:'091'},
//     {label:'高级农艺师',value:'092'},
//     {label:'农艺师',value:'093'},
//     {label:'助理农艺师',value:'094'},
//     {label:'农业技术员',value:'095'},
//     {label:'农业技术人员（兽医）',value:'100'},
//     {label:'农业技术推广研究员（兽医）',value:'101'},
//     {label:'高级兽医师',value:'102'},
//     {label:'兽医师',value:'103'},
//     {label:'助理兽医师',value:'104'},
//     {label:'兽医技术员',value:'105'},
//     {label:'农业技术人员（畜牧）',value:'110'},
//     {label:'农业技术推广研究员（畜牧）',value:'111'},
//     {label:'高级畜牧师',value:'112'},
//     {label:'畜牧师',value:'113'},
//     {label:'助理畜牧师',value:'114'},
//     {label:'畜牧技术员',value:'115'},
//     {label:'经济专业人员',value:'120'},
//     {label:'高级经济师',value:'122'},
//     {label:'经济师',value:'123'},
//     {label:'助理经济师',value:'124'},
//     {label:'经济员',value:'125'},
//     {label:'会计专业人员',value:'130'},
//     {label:'高级会计师',value:'132'},
//     {label:'会计师',value:'133'},
//     {label:'助理会计师',value:'134'},
//     {label:'会计员',value:'135'},
//     {label:'统计专业人员',value:'140'},
//     {label:'高级统计师',value:'142'},
//     {label:'统计师',value:'143'},
//     {label:'助理统计师',value:'144'},
//     {label:'统计员',value:'145'},
//     {label:'出版专业人员（编辑）',value:'150'},
//     {label:'编审',value:'151'},
//     {label:'副编审',value:'152'},
//     {label:'编辑',value:'153'},
//     {label:'助理编辑',value:'154'},
//     {label:'出版专业人员（技术编辑）',value:'160'},
//     {label:'技术编辑',value:'163'},
//     {label:'助理技术编辑',value:'164'},
//     {label:'技术设计员',value:'165'},
//     {label:'出版专业人员（校对）',value:'170'},
//     {label:'一级校对',value:'173'},
//     {label:'二级校对',value:'174'},
//     {label:'三级校对',value:'175'},
//     {label:'翻译人员',value:'180'},
//     {label:'译审（资深翻译）',value:'181'},
//     {label:'副译审（一级翻译）',value:'182'},
//     {label:'翻译',value:'183'},
//     {label:'助理翻译',value:'184'},
//     {label:'新闻专业人员（记者）',value:'190'},
//     {label:'高级记者',value:'191'},
//     {label:'主任记者',value:'192'},
//     {label:'记者',value:'193'},
//     {label:'助理记者',value:'194'},
//     {label:'新闻专业人员（编辑）',value:'200'},
//     {label:'高级编辑',value:'201'},
//     {label:'主任编辑',value:'202'},
//     {label:'编辑',value:'203'},
//     {label:'助理编辑',value:'204'},
//     {label:'广播电视播音员',value:'220'},
//     {label:'播音指导',value:'221'},
//     {label:'主任播音员',value:'222'},
//     {label:'一级播音员',value:'223'},
//     {label:'二级播音员',value:'224'},
//     {label:'三级播音员',value:'225'},
//     {label:'卫生技术人员（医师）',value:'230'},
//     {label:'主任医师',value:'231'},
//     {label:'副主任医师',value:'232'},
//     {label:'主治（主管）医师',value:'233'},
//     {label:'医师',value:'234'},
//     {label:'医士',value:'235'},
//     {label:'卫生技术人员（药剂）',value:'240'},
//     {label:'主任药师',value:'241'},
//     {label:'副主任药师',value:'242'},
//     {label:'主管药师',value:'243'},
//     {label:'药师',value:'244'},
//     {label:'药士',value:'245'},
//     {label:'卫生技术人员（护理）',value:'250'},
//     {label:'主任护师',value:'251'},
//     {label:'副主任护师',value:'252'},
//     {label:'主管护师',value:'253'},
//     {label:'护师',value:'254'},
//     {label:'护士',value:'255'},
//     {label:'卫生技术人员（技师）',value:'260'},
//     {label:'主任技师',value:'261'},
//     {label:'副主任技师',value:'262'},
//     {label:'主管技师',value:'263'},
//     {label:'技师',value:'264'},
//     {label:'技士',value:'265'},
//     {label:'工艺美术专业人员',value:'270'},
//     {label:'高级工艺美术师',value:'272'},
//     {label:'工艺美术师',value:'273'},
//     {label:'助理工艺美术师',value:'274'},
//     {label:'工艺美术员',value:'275'},
//     {label:'艺术人员（演员）',value:'280'},
//     {label:'一级演员',value:'281'},
//     {label:'二级演员',value:'282'},
//     {label:'三级演员',value:'283'},
//     {label:'四级演员',value:'284'},
//     {label:'艺术人员（演奏员）',value:'290'},
//     {label:'一级演奏员',value:'291'},
//     {label:'二级演奏员',value:'292'},
//     {label:'三级演奏员',value:'293'},
//     {label:'四级演奏员',value:'294'},
//     {label:'艺术人员（编剧）',value:'300'},
//     {label:'一级编剧',value:'301'},
//     {label:'二级编剧',value:'302'},
//     {label:'三级编剧',value:'303'},
//     {label:'四级编剧',value:'304'},
//     {label:'艺术人员（导演）',value:'310'},
//     {label:'一级导演',value:'311'},
//     {label:'二级导演',value:'312'},
//     {label:'三级导演',value:'313'},
//     {label:'四级导演',value:'314'},
//     {label:'艺术人员（指挥）',value:'320'},
//     {label:'一级指挥',value:'321'},
//     {label:'二级指挥',value:'322'},
//     {label:'三级指挥',value:'323'},
//     {label:'四级指挥',value:'324'},
//     {label:'艺术人员（作曲）',value:'330'},
//     {label:'一级作曲',value:'331'},
//     {label:'二级作曲',value:'332'},
//     {label:'三级作曲',value:'333'},
//     {label:'四级作曲',value:'334'},
//     {label:'艺术人员（美术）',value:'340'},
//     {label:'一级美术师',value:'341'},
//     {label:'二级美术师',value:'342'},
//     {label:'三级美术师',value:'343'},
//     {label:'美术员',value:'344'},
//     {label:'艺术人员（舞美设计）',value:'350'},
//     {label:'一级舞美设计师',value:'351'},
//     {label:'二级舞美设计师',value:'352'},
//     {label:'三级舞美设计师',value:'353'},
//     {label:'四级舞美设计员',value:'355'},
//     {label:'艺术人员（舞台设计）',value:'360'},
//     {label:'主任舞台技师',value:'362'},
//     {label:'舞台技师',value:'363'},
//     {label:'舞台技术员',value:'364'},
//     {label:'教练员',value:'370'},
//     {label:'国家级教练',value:'371'},
//     {label:'高级教练',value:'372'},
//     {label:'教练',value:'376'},
//     {label:'助理教练',value:'377'},
//     {label:'律师',value:'390'},
//     {label:'一级律师',value:'391'},
//     {label:'二级律师',value:'392'},
//     {label:'三级律师',value:'393'},
//     {label:'四级律师',value:'394'},
//     {label:'律师助理',value:'395'},
//     {label:'公证员',value:'400'},
//     {label:'一级公证员',value:'401'},
//     {label:'二级公证员',value:'402'},
//     {label:'三级公证员',value:'403'},
//     {label:'四级公证员',value:'404'},
//     {label:'公证助理员',value:'405'},
//     {label:'小学（幼儿园）教师',value:'410'},
//     {label:'高级教师（小学）',value:'413'},
//     {label:'一级教师（小学）',value:'414'},
//     {label:'二级教师（小学）',value:'415'},
//     {label:'三级教师（小学）',value:'416'},
//     {label:'船舶技术人员（驾驶）',value:'420'},
//     {label:'高级船长',value:'422'},
//     {label:'船长（大副）',value:'423'},
//     {label:'二副',value:'424'},
//     {label:'三副',value:'425'},
//     {label:'船舶技术人员（轮机）',value:'430'},
//     {label:'高级轮机长',value:'432'},
//     {label:'轮机长（大管轮）',value:'433'},
//     {label:'二管轮',value:'434'},
//     {label:'三管轮',value:'435'},
//     {label:'船舶技术人员（电机）',value:'440'},
//     {label:'高级电机员',value:'442'},
//     {label:'通用电机员（一等电机员）',value:'443'},
//     {label:'二等电机员',value:'444'},
//     {label:'船舶技术人员（报务）',value:'450'},
//     {label:'高级报务员',value:'452'},
//     {label:'通用报务员',value:'453'},
//     {label:'二等报务员',value:'454'},
//     {label:'限用报务员',value:'455'},
//     {label:'飞行技术人员（驾驶）',value:'460'},
//     {label:'一级飞行员',value:'462'},
//     {label:'二级飞行员',value:'463'},
//     {label:'三级飞行员',value:'464'},
//     {label:'四级飞行员',value:'465'},
//     {label:'飞行技术人员（领航）',value:'470'},
//     {label:'一级领航员',value:'472'},
//     {label:'二级领航员',value:'473'},
//     {label:'三级领航员',value:'474'},
//     {label:'四级领航员',value:'475'},
//     {label:'飞行技术人员（通信）',value:'480'},
//     {label:'一级飞行通信员',value:'482'},
//     {label:'二级飞行通信员',value:'483'},
//     {label:'三级飞行通信员',value:'484'},
//     {label:'四级飞行通信员',value:'485'},
//     {label:'飞行技术人员（机械）',value:'490'},
//     {label:'一级飞行机械员',value:'492'},
//     {label:'二级飞行机械员',value:'493'},
//     {label:'三级飞行机械员',value:'494'},
//     {label:'四级飞行机械员',value:'495'},
//     {label:'自然科学研究人员',value:'610'},
//     {label:'研究员（自然科学）',value:'611'},
//     {label:'副研究员（自然科学）',value:'612'},
//     {label:'助理研究员（自然科学）',value:'613'},
//     {label:'研究实习员（自然科学）',value:'614'},
//     {label:'社会科学研究人员',value:'620'},
//     {label:'研究员（社会科学）',value:'621'},
//     {label:'副研究员（社会科学）',value:'622'},
//     {label:'助理研究员（社会科学）',value:'623'},
//     {label:'研究实习员（社会科学）',value:'624'},
//     {label:'图书、资料专业人员',value:'640'},
//     {label:'研究馆员（图书）',value:'641'},
//     {label:'副研究馆员（图书）',value:'642'},
//     {label:'馆员（图书）',value:'643'},
//     {label:'助理馆员（图书）',value:'644'},
//     {label:'管理员（图书）',value:'645'},
//     {label:'文博专业人员',value:'650'},
//     {label:'研究馆员（文博）',value:'651'},
//     {label:'副研究馆员（文博）',value:'652'},
//     {label:'馆员（文博）',value:'653'},
//     {label:'助理馆员（文博）',value:'654'},
//     {label:'管理员（文博）',value:'655'},
//     {label:'档案专业人员',value:'660'},
//     {label:'研究馆员（档案）',value:'661'},
//     {label:'副研究馆员（档案）',value:'662'},
//     {label:'馆员（档案）',value:'663'},
//     {label:'助理馆员（档案）',value:'664'},
//     {label:'管理员（档案）',value:'665'},
//     {label:'其他',value:'999'},
//     {label:'未填写',value:'000'},
//   ],
//   // 工作环境
//   gongzuohuanjing:[
//     {label:'室内',value:'1'},
//     {label:'室外',value:'2'},
//     {label:'其他',value:'3'},
//     {label:'未填写)',value:'0'},
//   ],
//   // 工作性质
//   gongzuoxingzhi:[
//     {label:'全职',value:'1'},
//     {label:'兼职',value:'2'},
//     {label:'实习',value:'3'},
//     {label:'临时',value:'4'},
//     {label:'小时工',value:'5'},
//     {label:'均可',value:'6'},
//     {label:'其他',value:'9'},
//   ],
//   // 政治面貌
//   zhengzhimianmao:[
//     {label:'中共党员',value:'01'},
//     {label:'中共预备党员',value:'02'},
//     {label:'共青团员',value:'03'},
//     {label:'民革会员',value:'04'},
//     {label:'民盟盟员',value:'05'},
//     {label:'民建会员',value:'06'},
//     {label:'民进会员',value:'07'},
//     {label:'农工党党员',value:'08'},
//     {label:'致公党党员',value:'09'},
//     {label:'九三学社社员',value:'10'},
//     {label:'台盟盟员',value:'11'},
//     {label:'无党派民主人士',value:'12'},
//     {label:'群众',value:'13'},
//   ],
//   // 外语语种
//   yuzhong:[
//     {label:'阿法尔语',value:'aa'},
//     {label:'阿布哈兹语',value:'ab'},
//     {label:'阿维斯陀语',value:'ae'},
//     {label:'阿非利堪斯语',value:'af'},
//     {label:'阿坎语',value:'ak'},
//     {label:'阿姆哈拉语',value:'am'},
//     {label:'阿拉伯语',value:'ar'},
//     {label:'阿萨姆语',value:'as'},
//     {label:'阿瓦尔语',value:'av'},
//     {label:'艾马拉语',value:'ay'},
//     {label:'阿塞拜疆语',value:'az'},
//     {label:'巴什基尔语',value:'ba'},
//     {label:'白俄罗斯语',value:'be'},
//     {label:'保加利亚语',value:'bg'},
//     {label:'比哈尔语',value:'bh'},
//     {label:'比斯拉玛语',value:'bi'},
//     {label:'班巴拉语',value:'bm'},
//     {label:'孟加拉语',value:'bn'},
//     {label:'藏语',value:'bo'},
//     {label:'布列塔尼语',value:'br'},
//     {label:'波斯尼亚语',value:'bs'},
//     {label:'加泰隆语',value:'ca'},
//     {label:'车臣语',value:'ce'},
//     {label:'查莫罗语',value:'ch'},
//     {label:'科西嘉语',value:'co'},
//     {label:'克里语',value:'cr'},
//     {label:'捷克语',value:'cs'},
//     {label:'教会斯拉夫语',value:'cu'},
//     {label:'楚瓦什语',value:'cv'},
//     {label:'威尔士语',value:'cy'},
//     {label:'丹麦语',value:'da'},
//     {label:'德语',value:'de'},
//     {label:'马尔代夫语/迪维希语',value:'dv'},
//     {label:'不丹语',value:'dz'},
//     {label:'埃维语',value:'ee'},
//     {label:'现代希腊语(公元1453年以后)',value:'el'},
//     {label:'英语',value:'en'},
//     {label:'世界语',value:'eo'},
//     {label:'西班牙语',value:'es'},
//     {label:'爱沙尼亚语',value:'et'},
//     {label:'巴斯克语',value:'eu'},
//     {label:'波斯语',value:'fa'},
//     {label:'颇尔语/富拉语',value:'ff'},
//     {label:'芬兰语',value:'fi'},
//     {label:'斐济语',value:'fj'},
//     {label:'法罗斯语',value:'fo'},
//     {label:'法语',value:'fr'},
//     {label:'弗里西亚语',value:'fy'},
//     {label:'爱尔兰语',value:'ga'},
//     {label:'苏格兰语/盖尔语（苏格兰）',value:'gd'},
//     {label:'加利西亚语',value:'gl'},
//     {label:'瓜拉尼语',value:'gn'},
//     {label:'古吉拉特语',value:'gu'},
//     {label:'马恩岛语',value:'gv'},
//     {label:'豪萨语',value:'ha'},
//     {label:'希伯来语',value:'he'},
//     {label:'印地语',value:'hi'},
//     {label:'希里莫图语',value:'ho'},
//     {label:'克罗地亚语',value:'hr'},
//     {label:'匈牙利语',value:'hu'},
//     {label:'亚美尼亚语',value:'hy'},
//     {label:'赫雷罗语',value:'hz'},
//     {label:'国际语A',value:'ia'},
//     {label:'印尼语',value:'id'},
//     {label:'国际语E',value:'ie'},
//     {label:'伊博语',value:'ig'},
//     {label:'依努庇克语',value:'ik'},
//     {label:'伊多语',value:'io'},
//     {label:'冰岛语',value:'is'},
//     {label:'意大利语',value:'it'},
//     {label:'伊努伊特语',value:'iu'},
//     {label:'日语',value:'ja'},
//     {label:'爪哇语',value:'jv'},
//     {label:'格鲁吉亚语',value:'ka'},
//     {label:'刚果语',value:'kg'},
//     {label:'基库尤语',value:'ki'},
//     {label:'夸尼亚码语',value:'kj'},
//     {label:'哈萨克语',value:'kk'},
//     {label:'格陵兰语',value:'kl'},
//     {label:'柬埔寨语/高棉语',value:'km'},
//     {label:'坎纳达语',value:'kn'},
//     {label:'朝鲜语',value:'ko'},
//     {label:'卡努里语',value:'kr'},
//     {label:'克什米尔语',value:'ks'},
//     {label:'库尔德语',value:'ku'},
//     {label:'科米语',value:'kv'},
//     {label:'康沃尔语',value:'kw'},
//     {label:'吉尔吉斯语',value:'ky'},
//     {label:'拉丁语',value:'la'},
//     {label:'卢森堡语',value:'lb'},
//     {label:'干达语',value:'lg'},
//     {label:'林加拉语',value:'ln'},
//     {label:'老挝语',value:'lo'},
//     {label:'立陶宛语',value:'lt'},
//     {label:'卢巴—加丹加语',value:'lu'},
//     {label:'拉脱维亚语',value:'lv'},
//     {label:'马达加斯加语',value:'mg'},
//     {label:'马绍尔语',value:'mh'},
//     {label:'毛利语',value:'mi'},
//     {label:'马其顿语',value:'mk'},
//     {label:'马拉亚拉姆语',value:'ml'},
//     {label:'蒙古语',value:'mn'},
//     {label:'摩尔达维亚语',value:'mo'},
//     {label:'马拉提语',value:'mr'},
//     {label:'马来语',value:'ms'},
//     {label:'马耳他语',value:'mt'},
//     {label:'缅甸语',value:'my'},
//     {label:'瑙鲁语',value:'na'},
//     {label:'挪威布克摩尔语',value:'nb'},
//     {label:'北恩德贝勒语',value:'nd'},
//     {label:'尼泊尔语',value:'ne'},
//     {label:'恩敦加语',value:'ng'},
//     {label:'荷兰语',value:'nl'},
//     {label:'尼诺斯克挪威语',value:'nn'},
//     {label:'挪威语',value:'no'},
//     {label:'南恩德贝勒语',value:'nr'},
//     {label:'纳瓦霍语',value:'nv'},
//     {label:'班图语/尼扬贾语',value:'ny'},
//     {label:'奥吉西唐语（公元1500年以后）/普罗旺斯语(公元1500年以后)',value:'oc'},
//     {label:'奥吉布瓦语',value:'oj'},
//     {label:'库希特语/阿芳·奥洛莫语',value:'om'},
//     {label:'奥利亚语',value:'or'},
//     {label:'奥塞梯语',value:'os'},
//     {label:'旁遮普语',value:'pa'},
//     {label:'巴利语',value:'pi'},
//     {label:'波兰语',value:'pl'},
//     {label:'普什图语',value:'ps'},
//     {label:'葡萄牙语',value:'pt'},
//     {label:'凯楚亚语',value:'qu'},
//     {label:'利托-罗曼语',value:'rm'},
//     {label:'基隆迪语',value:'rn'},
//     {label:'曼尼普尔语',value:'ro'},
//     {label:'俄语',value:'ru'},
//     {label:'卢旺达语/基尼阿万达语',value:'rw'},
//     {label:'梵语',value:'sa'},
//     {label:'撒丁语',value:'sc'},
//     {label:'信德语',value:'sd'},
//     {label:'北萨摩斯语',value:'se'},
//     {label:'桑戈语',value:'sg'},
//     {label:'塞尔维亚--克罗地亚语',value:'sh'},
//     {label:'僧加罗语',value:'si'},
//     {label:'斯洛伐克语',value:'sk'},
//     {label:'斯洛文尼亚语',value:'sl'},
//     {label:'萨摩亚语',value:'sm'},
//     {label:'绍纳语',value:'sn'},
//     {label:'索马里语',value:'so'},
//     {label:'阿尔巴尼亚语',value:'sq'},
//     {label:'塞尔维亚语',value:'sr'},
//     {label:'塞斯瓦特语',value:'ss'},
//     {label:'南索托语',value:'st'},
//     {label:'巽他语',value:'su'},
//     {label:'瑞典语',value:'sv'},
//     {label:'斯瓦希里语',value:'sw'},
//     {label:'泰米尔语',value:'ta'},
//     {label:'泰卢固语',value:'te'},
//     {label:'塔吉克语',value:'tg'},
//     {label:'泰语',value:'th'},
//     {label:'提格里尼亚语',value:'ti'},
//     {label:'土库曼语',value:'tk'},
//     {label:'他加禄语',value:'tl'},
//     {label:'茨瓦纳语/塞茨瓦纳语',value:'tn'},
//     {label:'汤加语(汤加岛)',value:'to'},
//     {label:'土耳其语',value:'tr'},
//     {label:'宗加语',value:'ts'},
//     {label:'塔塔尔语',value:'tt'},
//     {label:'特威语',value:'tw'},
//     {label:'塔希提语',value:'ty'},
//     {label:'维吾尔语',value:'ug'},
//     {label:'乌克兰语',value:'uk'},
//     {label:'乌尔都语',value:'ur'},
//     {label:'乌兹别克语',value:'uz'},
//     {label:'文达语',value:'ve'},
//     {label:'越南语',value:'vi'},
//     {label:'沃拉普克语',value:'vo'},
//     {label:'瓦隆语',value:'wa'},
//     {label:'沃洛夫语',value:'wo'},
//     {label:'科萨语',value:'xh'},
//     {label:'依地语',value:'yi'},
//     {label:'约鲁巴语',value:'yo'},
//     {label:'状语',value:'za'},
//     {label:'汉语(中文)',value:'zh'},
//     {label:'祖鲁语',value:'zu'},
//     {label:'其他语言',value:'zz'},
//     {label:'印尼语',value:'id'},
//     {label:'英语',value:'en'},
//     {label:'约鲁巴语',value:'yo'},
//     {label:'越南语',value:'vi'},
//     {label:'藏语',value:'bo'},
//     {label:'爪哇语',value:'jv'},
//     {label:'状语',value:'za'},
//     {label:'宗加语',value:'ts'},
//     {label:'祖鲁语',value:'zu'},
//   ],
//   // 外语水平 计算机水平
//   shuiping:[
//     {label:'精通',value:'1'},
//     {label:'熟练',value:'2'},
//     {label:'良好',value:'3'},
//     {label:'一般',value:'4'},
//     {label:'其他',value:'9'},
//     {label:'未填写',value:'0'},
//   ],
//   // 试用期月工资档次
//   gongzidangci:[
//     {label:'1000以下',value:'1'},
//     {label:'1000-1999',value:'2'},
//     {label:'2000-2999',value:'3'},
//     {label:'3000-3999',value:'4'},
//     {label:'4000-4999',value:'5'},
//     {label:'5000及以上',value:'6'},
//     {label:'其他',value:'9'},
//   ],
//   // 提供住宿标识 提供住房公积金标识
//   shifouqita:[
//     {label:'否',value:'0'},
//     {label:'是',value:'1'},
//     {label:'其他',value:'9'},
//   ],
//   // 发布状态 公开联系方式标识 招聘岗位审核标识
//   shifou:[
//     {label:'否',value:'0'},
//     {label:'是',value:'1'},
//   ],
//   // 审核状态
//   shenhezhuangtai:[
//     {label:'审核通过',value:'1'},
//     {label:'审核不通过',value:'2'},
//     {label:'待审核',value:'3'},
//   ],
//   // 数据更新标识
//   gengxinbiaoshi:[
//     {label:'新增',value:'1'},
//     {label:'更新',value:'2'},
//     {label:'删除',value:'3'},
//   ],
//   // 所属行业
//   suoshuhangye:[
//     {label:'农、林、牧、渔业',value:'0100'},
//     {label:'农业',value:'0101'},
//     {label:'林业',value:'0102'},
//     {label:'畜牧业',value:'0103'},
//     {label:'渔业',value:'0104'},
//     {label:'农、林、牧、渔服务业',value:'0105'},
//     {label:'采矿业',value:'0200'},
//     {label:'煤炭开采和洗选业',value:'0206'},
//     {label:'石油和天然气开采业',value:'0207'},
//     {label:'黑色金属矿采选业',value:'0208'},
//     {label:'有色金属矿采选业',value:'0209'},
//     {label:'非金属矿采选业',value:'0210'},
//     {label:'其他采矿业',value:'0211'},
//     {label:'制造业',value:'0300'},
//     {label:'农副食品加工业',value:'0313'},
//     {label:'食品制造业',value:'0314'},
//     {label:'饮料制造业',value:'0315'},
//     {label:'烟草制品业',value:'0316'},
//     {label:'纺织业',value:'0317'},
//     {label:'纺织服装、鞋、帽制造业',value:'0318'},
//     {label:'皮革、毛皮、羽毛(绒)及其制品业',value:'0319'},
//     {label:'木材加工及木、竹、藤、棕、草制品业',value:'0320'},
//     {label:'家具制造业',value:'0321'},
//     {label:'造纸及纸制品业',value:'0322'},
//     {label:'印刷业和记录媒介的复制',value:'0323'},
//     {label:'文教体育用品制造业',value:'0324'},
//     {label:'石油加工、炼焦及核燃料加工业',value:'0325'},
//     {label:'化学原料及化学制品制造业',value:'0326'},
//     {label:'医药制造业',value:'0327'},
//     {label:'化学纤维制造业',value:'0328'},
//     {label:'橡胶制品业',value:'0329'},
//     {label:'塑料制品业',value:'0330'},
//     {label:'非金属矿物制品业',value:'0331'},
//     {label:'黑色金属冶炼及压延加工业',value:'0332'},
//     {label:'有色金属冶炼及压延加工业',value:'0333'},
//     {label:'金属制品业',value:'0334'},
//     {label:'通用设备制造业',value:'0335'},
//     {label:'专用设备制造业',value:'0336'},
//     {label:'交通运输设备制造业',value:'0337'},
//     {label:'电气机械及器材制造业',value:'0339'},
//     {label:'通信设备、计算机及其他电子设备制造业',value:'0340'},
//     {label:'仪器仪表及文化、办公用机械制造业',value:'0341'},
//     {label:'工艺品及其他制造业',value:'0342'},
//     {label:'废弃资源和废旧材料回收加工业',value:'0343'},
//     {label:'电力、燃气及水的生产和供应业',value:'0400'},
//     {label:'电力、热力的生产和供应业',value:'0444'},
//     {label:'燃气生产和供应业',value:'0445'},
//     {label:'水的生产和供应业',value:'0446'},
//     {label:'建筑业',value:'0500'},
//     {label:'房屋和土木工程建筑业',value:'0547'},
//     {label:'建筑安装业',value:'0548'},
//     {label:'建筑装饰业',value:'0549'},
//     {label:'其他建筑业',value:'0550'},
//     {label:'交通运输、仓储和邮政业',value:'0600'},
//     {label:'铁路运输业',value:'0651'},
//     {label:'道路运输业',value:'0652'},
//     {label:'城市公共交通业',value:'0653'},
//     {label:'水上运输业',value:'0654'},
//     {label:'航空运输业',value:'0655'},
//     {label:'管道运输业',value:'0656'},
//     {label:'装卸搬运和其他运输服务业',value:'0657'},
//     {label:'仓储业',value:'0658'},
//     {label:'邮政业',value:'0659'},
//     {label:'信息传输、计算机服务和软件业',value:'0700'},
//     {label:'电信和其他信息传输服务业',value:'0760'},
//     {label:'计算机服务业',value:'0761'},
//     {label:'软件业',value:'0762'},
//     {label:'批发和零售业',value:'0800'},
//     {label:'批发业',value:'0863'},
//     {label:'零售业',value:'0865'},
//     {label:'住宿和餐饮业',value:'0900'},
//     {label:'住宿业',value:'0966'},
//     {label:'餐饮业',value:'0967'},
//     {label:'金融业',value:'1000'},
//     {label:'银行业',value:'1068'},
//     {label:'证券业',value:'1069'},
//     {label:'保险业',value:'1070'},
//     {label:'其他金融活动',value:'1071'},
//     {label:'房地产业',value:'1100'},
//     {label:'房地产业',value:'1172'},
//     {label:'租赁和商务服务业',value:'1200'},
//     {label:'租赁业',value:'1273'},
//     {label:'商务服务业',value:'1274'},
//     {label:'科学研究、技术服务和地质勘查业',value:'1300'},
//     {label:'研究与试验发展',value:'1375'},
//     {label:'专业技术服务业',value:'1376'},
//     {label:'科技交流和推广服务业',value:'1377'},
//     {label:'地质勘查业',value:'1378'},
//     {label:'水利、环境和公共设施管理业',value:'1400'},
//     {label:'水利管理业',value:'1479'},
//     {label:'环境管理业',value:'1480'},
//     {label:'公共设施管理业',value:'1481'},
//     {label:'居民服务和其他服务业',value:'1500'},
//     {label:'居民服务业',value:'1582'},
//     {label:'其他服务业',value:'1583'},
//     {label:'教育',value:'1600'},
//     {label:'教育',value:'1684'},
//     {label:'卫生、社会保障和社会福利业',value:'1700'},
//     {label:'卫生',value:'1785'},
//     {label:'社会保障业',value:'1786'},
//     {label:'社会福利业',value:'1787'},
//     {label:'文化、体育和娱乐业',value:'1800'},
//     {label:'新闻出版业',value:'1888'},
//     {label:'广播、电视、电影和音像业',value:'1889'},
//     {label:'文化艺术业',value:'1890'},
//     {label:'体育',value:'1891'},
//     {label:'娱乐业',value:'1892'},
//     {label:'公共管理和社会组织',value:'1900'},
//     {label:'中国共产党机关',value:'1993'},
//     {label:'国家机构',value:'1994'},
//     {label:'人民政协和民主党派',value:'1995'},
//     {label:'群众团体、社会团体和宗教组织',value:'1996'},
//     {label:'基层群众自治组织',value:'1997'},
//     {label:'国际组织',value:'2000'},
//     {label:'国际组织',value:'2098'},
//     {label:'其他行业',value:'9000'},
//     {label:'未填写',value:'0000'},
//   ],
//   // 单位类型
//   danweileixing:[
//     {label:'企业',value:'10'},
//     {label:'机关',value:'30'},
//     {label:'事业单位',value:'50'},
//     {label:'全额拨款事业单位',value:'55'},
//     {label:'差额拨款事业单位',value:'56'},
//     {label:'自收自支事业单位',value:'57'},
//     {label:'社会团体',value:'70'},
//     {label:'个体工商户(有雇工的)',value:'81'},
//     {label:'律师事务所',value:'82'},
//     {label:'会计师事务所',value:'83'},
//     {label:'民办非企业单位',value:'91'},
//     {label:'基金会',value:'93'},
//     {label:'境外非政府组织驻华代表机构',value:'97'},
//     {label:'其他',value:'99'},
//   ],
//   // 经济类型
//   jingjileixing:[
//     {label:'内资',value:'100'},
//     {label:'国有全资',value:'110'},
//     {label:'集体全资',value:'120'},
//     {label:'股份合作',value:'130'},
//     {label:'联营',value:'140'},
//     {label:'国有联营',value:'141'},
//     {label:'集体联营',value:'142'},
//     {label:'国有与集体联营',value:'143'},
//     {label:'其他联营',value:'149'},
//     {label:'有限责任(公司)',value:'150'},
//     {label:'国有独资(公司)',value:'151'},
//     {label:'其他有限责任(公司)',value:'159'},
//     {label:'股份有限(公司)',value:'160'},
//     {label:'私有',value:'170'},
//     {label:'私有独资',value:'171'},
//     {label:'私有合伙',value:'172'},
//     {label:'私营有限责任(公司)',value:'173'},
//     {label:'私营股份有限(公司)',value:'174'},
//     {label:'个体经营',value:'175'},
//     {label:'其他私有',value:'179'},
//     {label:'其他内资',value:'190'},
//     {label:'港、澳、台投资',value:'200'},
//     {label:'内地和港、澳、台合资',value:'210'},
//     {label:'内地和港、澳、台合作',value:'220'},
//     {label:'港、澳、台独资',value:'230'},
//     {label:'港、澳、台投资股份有限(公司)',value:'240'},
//     {label:'其他港、澳、台投资',value:'290'},
//     {label:'国外投资',value:'300'},
//     {label:'中外合资',value:'310'},
//     {label:'中外合作',value:'320'},
//     {label:'外资',value:'330'},
//     {label:'国外投资股份有限(公司)',value:'340'},
//     {label:'其他国外投资',value:'390'},
//     {label:'其他',value:'900'},
//     {label:'未填写',value:'000'},
//   ],
//   // 人员规模
//   renyuanguimo:[
//     {label:'3000人以上',value:'1'},
//     {label:'1000--2999人',value:'2'},
//     {label:'500--999人',value:'3'},
//     {label:'100--499人',value:'4'},
//     {label:'10--99人',value:'5'},
//     {label:'10人以下',value:'6'},
//     {label:'其他',value:'9'},
//     {label:'未填写',value:'0'},
//   ],
//   // 系人即时通讯类型
//   tongxunleixing:[
//     {label:'QQ',value:'1'},
//     {label:'MSN',value:'2'},
//     {label:'其他',value:'3'},
//   ],
//   // 机构状态
//   jigouzhuangtai:[
//     {label:'停用',value:'0'},
//     {label:'正常',value:'1'},
//   ],
//   // 有效性
//   youxiaoxing:[
//     {label:'无效',value:'0'},
//     {label:'有效',value:'1'},
//   ],
//   // areaMap
//   diqu:[
//     {label:'郴州市',value:'431000'},
//     {label:'郴州市市本级',value:'431099'},
//     {label:'北湖区',value:'431002'},
//     {label:'苏仙区',value:'431003'},
//     {label:'桂阳',value:'431021'},
//     {label:'宜章县',value:'431022'},
//     {label:'永兴县',value:'431023'},
//     {label:'嘉禾县',value:'431024'},
//     {label:'临武',value:'431025'},
//     {label:'汝城县',value:'431026'},
//     {label:'桂东县',value:'431027'},
//     {label:'安仁县',value:'431028'},
//     {label:'资兴市',value:'431081'},
//   ],
// }

export default {
  // 职业（工种）
  zhiyegongzhong:[
    {label:'企业管理人员',value:'企业管理人员'},
    {label:'部门经理',value:'部门经理'},
    {label:'其他企业管理人员',value:'其他企业管理人员'},
    {label:'专业、技术人员',value:'专业、技术人员'},
    {label:'科研人员',value:'科研人员'},
    {label:'科研人员',value:'科研人员'},
    {label:'工程技术人员',value:'工程技术人员'},
    {label:'地质勘探工程技术人员',value:'地质勘探工程技术人员'},
    {label:'测绘工程技术人员',value:'测绘工程技术人员'},
    {label:'矿山工程技术人员',value:'矿山工程技术人员'},
    {label:'石油工程技术人员',value:'石油工程技术人员'},
    {label:'冶金工程技术人员',value:'冶金工程技术人员'},
    {label:'化工工程技术人员',value:'化工工程技术人员'},
    {label:'机械工程技术人员',value:'机械工程技术人员'},
    {label:'兵器航空航天工程技术人员',value:'兵器航空航天工程技术人员'},
    {label:'电子工程技术人员',value:'电子工程技术人员'},
    {label:'通信工程技术人员',value:'通信工程技术人员'},
    {label:'计算机工程技术人员',value:'计算机工程技术人员'},
    {label:'电气工程技术人员',value:'电气工程技术人员'},
    {label:'电力工程技术人员',value:'电力工程技术人员'},
    {label:'邮政工程技术人员',value:'邮政工程技术人员'},
    {label:'广播影视工程技术人员',value:'广播影视工程技术人员'},
    {label:'交通工程技术人员',value:'交通工程技术人员'},
    {label:'民用航空工程技术人员',value:'民用航空工程技术人员'},
    {label:'铁路工程技术人员',value:'铁路工程技术人员'},
    {label:'建筑工程技术人员',value:'建筑工程技术人员'},
    {label:'建材工程技术人员',value:'建材工程技术人员'},
    {label:'家具设计、林业工程技术人员',value:'家具设计、林业工程技术人员'},
    {label:'水利工程技术人员',value:'水利工程技术人员'},
    {label:'海洋工程技术人员',value:'海洋工程技术人员'},
    {label:'水产工程技术人员',value:'水产工程技术人员'},
    {label:'纺织工程技术人员',value:'纺织工程技术人员'},
    {label:'食品工程技术人员',value:'食品工程技术人员'},
    {label:'气象工程技术人员',value:'气象工程技术人员'},
    {label:'地震工程技术人员',value:'地震工程技术人员'},
    {label:'环境保护工程技术人员',value:'环境保护工程技术人员'},
    {label:'安全工程技术人员',value:'安全工程技术人员'},
    {label:'标准化、计量、质量工程技术人员',value:'标准化、计量、质量工程技术人员'},
    {label:'工业管理工程技术人员',value:'工业管理工程技术人员'},
    {label:'生物工程技术人员',value:'生物工程技术人员'},
    {label:'其他工程技术人员',value:'其他工程技术人员'},
    {label:'农业技术人员',value:'农业技术人员'},
    {label:'土壤肥料技术人员',value:'土壤肥料技术人员'},
    {label:'植物保护技术人员',value:'植物保护技术人员'},
    {label:'园艺技术人员',value:'园艺技术人员'},
    {label:'作物遗传育种栽培技术人员',value:'作物遗传育种栽培技术人员'},
    {label:'兽医兽药技术人员',value:'兽医兽药技术人员'},
    {label:'畜牧与草业技术人员',value:'畜牧与草业技术人员'},
    {label:'其他农业技术人员',value:'其他农业技术人员'},
    {label:'飞机船舶技术人员',value:'飞机船舶技术人员'},
    {label:'船舶指挥引航人员',value:'船舶指挥引航人员'},
    {label:'其他飞机船舶技术人员',value:'其他飞机船舶技术人员'},
    {label:'卫生专业技术人员',value:'卫生专业技术人员'},
    {label:'西医',value:'西医'},
    {label:'中医',value:'中医'},
    {label:'公共卫生医师',value:'公共卫生医师'},
    {label:'药剂师',value:'药剂师'},
    {label:'医疗技术人员',value:'医疗技术人员'},
    {label:'护士',value:'护士'},
    {label:'其他卫生专业技术人员',value:'其他卫生专业技术人员'},
    {label:'经济业务人员',value:'经济业务人员'},
    {label:'经济计划人员',value:'经济计划人员'},
    {label:'统计师',value:'统计师'},
    {label:'财会人员',value:'财会人员'},
    {label:'审计师',value:'审计师'},
    {label:'国际商务人员',value:'国际商务人员'},
    {label:'房地产业务人员',value:'房地产业务人员'},
    {label:'其他经济业务人员',value:'其他经济业务人员'},
    {label:'金融业务人员',value:'金融业务人员'},
    {label:'银行业务人员',value:'银行业务人员'},
    {label:'保险业务人员',value:'保险业务人员'},
    {label:'证券业务人员',value:'证券业务人员'},
    {label:'其他金融业务人员',value:'其他金融业务人员'},
    {label:'法律专业人员',value:'法律专业人员'},
    {label:'律师',value:'律师'},
    {label:'其他法律专业人员',value:'其他法律专业人员'},
    {label:'教学人员',value:'教学人员'},
    {label:'高等教育教师',value:'高等教育教师'},
    {label:'中等职业教育教师',value:'中等职业教育教师'},
    {label:'中学教师',value:'中学教师'},
    {label:'小学教师',value:'小学教师'},
    {label:'幼儿教师',value:'幼儿教师'},
    {label:'特殊教育教师',value:'特殊教育教师'},
    {label:'其他教学人员',value:'其他教学人员'},
    {label:'文学艺术工作者',value:'文学艺术工作者'},
    {label:'文艺创作和评论人员',value:'文艺创作和评论人员'},
    {label:'编导和音乐指挥人员',value:'编导和音乐指挥人员'},
    {label:'演员',value:'演员'},
    {label:'乐器演奏员',value:'乐器演奏员'},
    {label:'影视制作及舞台专业人员',value:'影视制作及舞台专业人员'},
    {label:'美术专业人员',value:'美术专业人员'},
    {label:'工美装饰服装广告设计人员',value:'工美装饰服装广告设计人员'},
    {label:'装璜美术设计人员',value:'装璜美术设计人员'},
    {label:'服装设计师',value:'服装设计师'},
    {label:'室内装饰设计人员',value:'室内装饰设计人员'},
    {label:'广告设计人员',value:'广告设计人员'},
    {label:'其他文学艺术工作者',value:'其他文学艺术工作者'},
    {label:'体育工作者',value:'体育工作者'},
    {label:'体育工作者',value:'体育工作者'},
    {label:'新闻出版文化工作者',value:'新闻出版文化工作者'},
    {label:'记者',value:'记者'},
    {label:'编辑',value:'编辑'},
    {label:'播音员及节目主持人',value:'播音员及节目主持人'},
    {label:'翻译',value:'翻译'},
    {label:'图书资料档案业务人员',value:'图书资料档案业务人员'},
    {label:'其他新闻出版、文化工作者',value:'其他新闻出版、文化工作者'},
    {label:'办事人员',value:'办事人员'},
    {label:'行政办公人员',value:'行政办公人员'},
    {label:'行政业务人员',value:'行政业务人员'},
    {label:'秘书、打字员',value:'秘书、打字员'},
    {label:'其他行政办公人员',value:'其他行政办公人员'},
    {label:'安全保卫和消防人员',value:'安全保卫和消防人员'},
    {label:'治安保卫人员',value:'治安保卫人员'},
    {label:'其他安全保卫消防人员',value:'其他安全保卫消防人员'},
    {label:'邮政电信业务人员',value:'邮政电信业务人员'},
    {label:'邮政业务人员',value:'邮政业务人员'},
    {label:'电信业务人员、话务员',value:'电信业务人员、话务员'},
    {label:'电信通信传输业务人员',value:'电信通信传输业务人员'},
    {label:'其他邮政电信业务人员',value:'其他邮政电信业务人员'},
    {label:'商业、服务业人员',value:'商业、服务业人员'},
    {label:'购销人员',value:'购销人员'},
    {label:'营业人员、收银员',value:'营业人员、收银员'},
    {label:'推销展销人员',value:'推销展销人员'},
    {label:'采购人员',value:'采购人员'},
    {label:'废旧物资回收利用人员',value:'废旧物资回收利用人员'},
    {label:'商品监督和市场管理员',value:'商品监督和市场管理员'},
    {label:'医药商品购销员',value:'医药商品购销员'},
    {label:'其他购销人员',value:'其他购销人员'},
    {label:'仓储人员',value:'仓储人员'},
    {label:'保管人员',value:'保管人员'},
    {label:'储运人员',value:'储运人员'},
    {label:'其他仓储人员',value:'其他仓储人员'},
    {label:'餐饮服务人员',value:'餐饮服务人员'},
    {label:'中餐烹饪人员',value:'中餐烹饪人员'},
    {label:'西餐烹饪人员',value:'西餐烹饪人员'},
    {label:'调酒和茶艺人员',value:'调酒和茶艺人员'},
    {label:'餐厅服务员、厨工',value:'餐厅服务员、厨工'},
    {label:'其他餐饮服务人员',value:'其他餐饮服务人员'},
    {label:'饭店、旅游娱乐服务员',value:'饭店、旅游娱乐服务员'},
    {label:'饭店服务人员',value:'饭店服务人员'},
    {label:'旅游游览场所服务员',value:'旅游游览场所服务员'},
    {label:'健身娱乐场所服务员',value:'健身娱乐场所服务员'},
    {label:'其他旅游健身娱乐服务人员',value:'其他旅游健身娱乐服务人员'},
    {label:'运输服务人员',value:'运输服务人员'},
    {label:'公路运输服务人员',value:'公路运输服务人员'},
    {label:'铁路运输服务人员',value:'铁路运输服务人员'},
    {label:'航空运输服务人员',value:'航空运输服务人员'},
    {label:'水上运输服务人员',value:'水上运输服务人员'},
    {label:'其他运输服务人员',value:'其他运输服务人员'},
    {label:'医疗卫生辅助服务人员',value:'医疗卫生辅助服务人员'},
    {label:'护理人员',value:'护理人员'},
    {label:'其他医疗卫生辅助服务人员',value:'其他医疗卫生辅助服务人员'},
    {label:'社会服务人员',value:'社会服务人员'},
    {label:'社会中介服务人员',value:'社会中介服务人员'},
    {label:'物业管理人员',value:'物业管理人员'},
    {label:'供水供热人员、锅炉工',value:'供水供热人员、锅炉工'},
    {label:'美发美容人员',value:'美发美容人员'},
    {label:'摄影服务人员',value:'摄影服务人员'},
    {label:'验光配镜人员',value:'验光配镜人员'},
    {label:'洗染、织补人员',value:'洗染、织补人员'},
    {label:'浴池服务人员',value:'浴池服务人员'},
    {label:'家用机电产品维修人员',value:'家用机电产品维修人员'},
    {label:'办公设备维修人员',value:'办公设备维修人员'},
    {label:'保育、家庭服务员',value:'保育、家庭服务员'},
    {label:'清洁工',value:'清洁工'},
    {label:'家庭教师',value:'家庭教师'},
    {label:'电梯工',value:'电梯工'},
    {label:'其他社会服务人员',value:'其他社会服务人员'},
    {label:'农林牧渔水利生产人员',value:'农林牧渔水利生产人员'},
    {label:'种植业生产人员',value:'种植业生产人员'},
    {label:'大田作物生产人员',value:'大田作物生产人员'},
    {label:'农业实验人员',value:'农业实验人员'},
    {label:'园艺作物生产人员',value:'园艺作物生产人员'},
    {label:'中药材生产人员',value:'中药材生产人员'},
    {label:'农副林特产品加工工',value:'农副林特产品加工工'},
    {label:'其他种植业生产人员',value:'其他种植业生产人员'},
    {label:'林业及动植物保护人员',value:'林业及动植物保护人员'},
    {label:'木材采运人员',value:'木材采运人员'},
    {label:'其他林业及野生动植物保护人员',value:'其他林业及野生动植物保护人员'},
    {label:'畜牧业生产人员',value:'畜牧业生产人员'},
    {label:'畜牧业生产人员',value:'畜牧业生产人员'},
    {label:'渔业生产人员',value:'渔业生产人员'},
    {label:'水产养殖人员',value:'水产养殖人员'},
    {label:'水产捕捞及有关人员',value:'水产捕捞及有关人员'},
    {label:'水产品加工工',value:'水产品加工工'},
    {label:'其他渔业生产人员',value:'其他渔业生产人员'},
    {label:'水利设施管理养护人员',value:'水利设施管理养护人员'},
    {label:'水利设施管理养护人员',value:'水利设施管理养护人员'},
    {label:'农林机械操作和能源开发人员',value:'农林机械操作和能源开发人员'},
    {label:'农林机械操作和能源开发人员',value:'农林机械操作和能源开发人员'},
    {label:'生产运输工人',value:'生产运输工人'},
    {label:'勘测及矿物开采工',value:'勘测及矿物开采工'},
    {label:'地质勘查人员',value:'地质勘查人员'},
    {label:'测绘人员',value:'测绘人员'},
    {label:'矿物开采工',value:'矿物开采工'},
    {label:'矿物处理工',value:'矿物处理工'},
    {label:'钻井人员',value:'钻井人员'},
    {label:'石油、天然气开采人员',value:'石油、天然气开采人员'},
    {label:'盐业生产人员',value:'盐业生产人员'},
    {label:'其他勘测及矿物开采工',value:'其他勘测及矿物开采工'},
    {label:'金属冶炼轧制工',value:'金属冶炼轧制工'},
    {label:'金属冶炼工',value:'金属冶炼工'},
    {label:'金属轧制工',value:'金属轧制工'},
    {label:'其他金属冶炼、轧制工',value:'其他金属冶炼、轧制工'},
    {label:'化工产品生产工',value:'化工产品生产工'},
    {label:'化工产品生产工',value:'化工产品生产工'},
    {label:'机械制造加工工',value:'机械制造加工工'},
    {label:'机械冷加工工',value:'机械冷加工工'},
    {label:'车工',value:'车工'},
    {label:'铣工',value:'铣工'},
    {label:'刨插工',value:'刨插工'},
    {label:'磨工',value:'磨工'},
    {label:'镗工',value:'镗工'},
    {label:'钻床工',value:'钻床工'},
    {label:'加工中心操作工',value:'加工中心操作工'},
    {label:'制齿工',value:'制齿工'},
    {label:'机械热加工工',value:'机械热加工工'},
    {label:'铸造工',value:'铸造工'},
    {label:'锻造工',value:'锻造工'},
    {label:'冲压工',value:'冲压工'},
    {label:'焊工',value:'焊工'},
    {label:'金属热处理工',value:'金属热处理工'},
    {label:'特种加工设备操作工',value:'特种加工设备操作工'},
    {label:'冷作钣金加工工',value:'冷作钣金加工工'},
    {label:'工件表面处理加工工',value:'工件表面处理加工工'},
    {label:'磨料磨具制造加工人员',value:'磨料磨具制造加工人员'},
    {label:'其他机械制造加工工',value:'其他机械制造加工工'},
    {label:'机电产品装配工',value:'机电产品装配工'},
    {label:'机械设备装配工',value:'机械设备装配工'},
    {label:'电气电子设备装配工',value:'电气电子设备装配工'},
    {label:'仪器仪表装配工',value:'仪器仪表装配工'},
    {label:'运输车辆装配工',value:'运输车辆装配工'},
    {label:'其他机电产品装配工',value:'其他机电产品装配工'},
    {label:'机械设备修理工',value:'机械设备修理工'},
    {label:'机械设备维修工',value:'机械设备维修工'},
    {label:'仪器仪表修理工',value:'仪器仪表修理工'},
    {label:'其他机械设备修理工',value:'其他机械设备修理工'},
    {label:'电力设备装运检修工',value:'电力设备装运检修工'},
    {label:'电力设备安装工',value:'电力设备安装工'},
    {label:'专业电力设备检修工',value:'专业电力设备检修工'},
    {label:'普通电力设备检修工、电工',value:'普通电力设备检修工、电工'},
    {label:'其他电力设备装运、检修及供电工',value:'其他电力设备装运、检修及供电工'},
    {label:'电子元器件制造装调工',value:'电子元器件制造装调工'},
    {label:'电子元件、器件制造工',value:'电子元件、器件制造工'},
    {label:'电子设备装配调试工',value:'电子设备装配调试工'},
    {label:'电子产品维修工',value:'电子产品维修工'},
    {label:'其他电子元器件与电子设备制造、装调维修工',value:'其他电子元器件与电子设备制造、装调维修工'},
    {label:'橡胶塑料制品生产工',value:'橡胶塑料制品生产工'},
    {label:'橡胶制品生产工',value:'橡胶制品生产工'},
    {label:'塑料制品加工工',value:'塑料制品加工工'},
    {label:'其他橡胶和塑料制品生产工',value:'其他橡胶和塑料制品生产工'},
    {label:'纺织针织印染工',value:'纺织针织印染工'},
    {label:'纤维预处理人员',value:'纤维预处理人员'},
    {label:'纺纱人员',value:'纺纱人员'},
    {label:'织造人员',value:'织造人员'},
    {label:'针织人员',value:'针织人员'},
    {label:'印染人员',value:'印染人员'},
    {label:'纺织、针织、印染工',value:'纺织、针织、印染工'},
    {label:'裁剪缝纫毛皮革制作工',value:'裁剪缝纫毛皮革制作工'},
    {label:'裁剪缝纫工',value:'裁剪缝纫工'},
    {label:'鞋帽制作工',value:'鞋帽制作工'},
    {label:'皮革、毛皮加工工',value:'皮革、毛皮加工工'},
    {label:'缝纫制品再加工人员',value:'缝纫制品再加工人员'},
    {label:'其他裁剪缝纫和毛皮革制作工',value:'其他裁剪缝纫和毛皮革制作工'},
    {label:'粮油食品饮料生产工',value:'粮油食品饮料生产工'},
    {label:'粮油食品饮料生产加工及饲料加工工',value:'粮油食品饮料生产加工及饲料加工工'},
    {label:'烟草制品加工工',value:'烟草制品加工工'},
    {label:'烟草制品加工工',value:'烟草制品加工工'},
    {label:'药品生产制造工',value:'药品生产制造工'},
    {label:'药品生产制造工',value:'药品生产制造工'},
    {label:'木材人造板生产制作工',value:'木材人造板生产制作工'},
    {label:'木材加工制作工',value:'木材加工制作工'},
    {label:'其他木材加工、人造板生产及木制品制作工',value:'其他木材加工、人造板生产及木制品制作工'},
    {label:'制浆造纸纸制品生产工',value:'制浆造纸纸制品生产工'},
    {label:'纸制品制作工',value:'纸制品制作工'},
    {label:'其他制浆、造纸和纸制品生产加工工',value:'其他制浆、造纸和纸制品生产加工工'},
    {label:'建筑材料生产加工工',value:'建筑材料生产加工工'},
    {label:'建筑材料生产加工工',value:'建筑材料生产加工工'},
    {label:'玻璃陶瓷搪瓷生产工',value:'玻璃陶瓷搪瓷生产工'},
    {label:'玻璃陶瓷搪瓷生产加工工',value:'玻璃陶瓷搪瓷生产加工工'},
    {label:'广播影视品制作播放人员',value:'广播影视品制作播放人员'},
    {label:'广播影视设备操作人员',value:'广播影视设备操作人员'},
    {label:'其他广播影视品制作播放及文物保护人员',value:'其他广播影视品制作播放及文物保护人员'},
    {label:'制版印刷人员',value:'制版印刷人员'},
    {label:'制版印刷人员',value:'制版印刷人员'},
    {label:'工艺、美术品制作人员',value:'工艺、美术品制作人员'},
    {label:'工艺、美术品制作人员',value:'工艺、美术品制作人员'},
    {label:'文体用品乐器制作人员',value:'文体用品乐器制作人员'},
    {label:'文体用品乐器制作人员',value:'文体用品乐器制作人员'},
    {label:'建筑和工程施工人员',value:'建筑和工程施工人员'},
    {label:'土石方施工人员',value:'土石方施工人员'},
    {label:'砌筑工',value:'砌筑工'},
    {label:'混凝土工',value:'混凝土工'},
    {label:'钢筋工',value:'钢筋工'},
    {label:'架子工',value:'架子工'},
    {label:'工程防水工',value:'工程防水工'},
    {label:'装饰、装修、油漆工',value:'装饰、装修、油漆工'},
    {label:'筑路、养护、维修人员',value:'筑路、养护、维修人员'},
    {label:'机械电气工程设备安装工、管工',value:'机械电气工程设备安装工、管工'},
    {label:'电工',value:'电工'},
    {label:'木工',value:'木工'},
    {label:'其他工程施工人员',value:'其他工程施工人员'},
    {label:'驾驶员和运输工人',value:'驾驶员和运输工人'},
    {label:'机动车驾驶员',value:'机动车驾驶员'},
    {label:'铁路、地铁运输设备操作及有关人员',value:'铁路、地铁运输设备操作及有关人员'},
    {label:'船舶水手',value:'船舶水手'},
    {label:'起重装卸机械操作工',value:'起重装卸机械操作工'},
    {label:'其他运输设备操作人员',value:'其他运输设备操作人员'},
    {label:'环境监测废物处理人员',value:'环境监测废物处理人员'},
    {label:'环境监测废物处理人员',value:'环境监测废物处理人员'},
    {label:'检验、计量人员',value:'检验、计量人员'},
    {label:'检验、计量人员',value:'检验、计量人员'},
    {label:'普通工人',value:'普通工人'},
    {label:'普通工',value:'普通工'},
  ],
  zhiyegongzhong_:[
    {label:'企业管理人员',value:'企业管理人员'},
    {label:'部门经理',value:'部门经理'},
    {label:'其他企业管理人员',value:'其他企业管理人员'},
    {label:'专业、技术人员',value:'专业、技术人员'},
    {label:'科研人员',value:'科研人员'},
    {label:'科研人员',value:'科研人员'},
    {label:'工程技术人员',value:'工程技术人员'},
    {label:'地质勘探工程技术人员',value:'地质勘探工程技术人员'},
    {label:'测绘工程技术人员',value:'测绘工程技术人员'},
    {label:'矿山工程技术人员',value:'矿山工程技术人员'},
    {label:'石油工程技术人员',value:'石油工程技术人员'},
    {label:'冶金工程技术人员',value:'冶金工程技术人员'},
    {label:'化工工程技术人员',value:'化工工程技术人员'},
    {label:'机械工程技术人员',value:'机械工程技术人员'},
    // {label:'兵器航空航天工程技术人员',value:'兵器航空航天工程技术人员'},
    {label:'电子工程技术人员',value:'电子工程技术人员'},
    {label:'通信工程技术人员',value:'通信工程技术人员'},
    {label:'计算机工程技术人员',value:'计算机工程技术人员'},
    {label:'电气工程技术人员',value:'电气工程技术人员'},
    {label:'电力工程技术人员',value:'电力工程技术人员'},
    {label:'邮政工程技术人员',value:'邮政工程技术人员'},
    {label:'广播影视工程技术人员',value:'广播影视工程技术人员'},
    {label:'交通工程技术人员',value:'交通工程技术人员'},
    {label:'民用航空工程技术人员',value:'民用航空工程技术人员'},
    {label:'铁路工程技术人员',value:'铁路工程技术人员'},
    {label:'建筑工程技术人员',value:'建筑工程技术人员'},
    {label:'建材工程技术人员',value:'建材工程技术人员'},
    // {label:'家具设计、林业工程技术人员',value:'家具设计、林业工程技术人员'},
    {label:'水利工程技术人员',value:'水利工程技术人员'},
    {label:'海洋工程技术人员',value:'海洋工程技术人员'},
    {label:'水产工程技术人员',value:'水产工程技术人员'},
    {label:'纺织工程技术人员',value:'纺织工程技术人员'},
    {label:'食品工程技术人员',value:'食品工程技术人员'},
    {label:'气象工程技术人员',value:'气象工程技术人员'},
    {label:'地震工程技术人员',value:'地震工程技术人员'},
    {label:'环境保护工程技术人员',value:'环境保护工程技术人员'},
    {label:'安全工程技术人员',value:'安全工程技术人员'},
    // {label:'标准化、计量、质量工程技术人员',value:'标准化、计量、质量工程技术人员'},
    {label:'工业管理工程技术人员',value:'工业管理工程技术人员'},
    {label:'生物工程技术人员',value:'生物工程技术人员'},
    {label:'其他工程技术人员',value:'其他工程技术人员'},
    {label:'农业技术人员',value:'农业技术人员'},
    {label:'土壤肥料技术人员',value:'土壤肥料技术人员'},
    {label:'植物保护技术人员',value:'植物保护技术人员'},
    {label:'园艺技术人员',value:'园艺技术人员'},
    // {label:'作物遗传育种栽培技术人员',value:'作物遗传育种栽培技术人员'},
    {label:'兽医兽药技术人员',value:'兽医兽药技术人员'},
    {label:'畜牧与草业技术人员',value:'畜牧与草业技术人员'},
    {label:'其他农业技术人员',value:'其他农业技术人员'},
    {label:'飞机船舶技术人员',value:'飞机船舶技术人员'},
    {label:'船舶指挥引航人员',value:'船舶指挥引航人员'},
    {label:'其他飞机船舶技术人员',value:'其他飞机船舶技术人员'},
    {label:'卫生专业技术人员',value:'卫生专业技术人员'},
    {label:'西医',value:'西医'},
    {label:'中医',value:'中医'},
    {label:'公共卫生医师',value:'公共卫生医师'},
    {label:'药剂师',value:'药剂师'},
    {label:'医疗技术人员',value:'医疗技术人员'},
    {label:'护士',value:'护士'},
    {label:'其他卫生专业技术人员',value:'其他卫生专业技术人员'},
    {label:'经济业务人员',value:'经济业务人员'},
    {label:'经济计划人员',value:'经济计划人员'},
    {label:'统计师',value:'统计师'},
    {label:'财会人员',value:'财会人员'},
    {label:'审计师',value:'审计师'},
    {label:'国际商务人员',value:'国际商务人员'},
    {label:'房地产业务人员',value:'房地产业务人员'},
    {label:'其他经济业务人员',value:'其他经济业务人员'},
    {label:'金融业务人员',value:'金融业务人员'},
    {label:'银行业务人员',value:'银行业务人员'},
    {label:'保险业务人员',value:'保险业务人员'},
    {label:'证券业务人员',value:'证券业务人员'},
    {label:'其他金融业务人员',value:'其他金融业务人员'},
    {label:'法律专业人员',value:'法律专业人员'},
    {label:'律师',value:'律师'},
    {label:'其他法律专业人员',value:'其他法律专业人员'},
    {label:'教学人员',value:'教学人员'},
    {label:'高等教育教师',value:'高等教育教师'},
    {label:'中等职业教育教师',value:'中等职业教育教师'},
    {label:'中学教师',value:'中学教师'},
    {label:'小学教师',value:'小学教师'},
    {label:'幼儿教师',value:'幼儿教师'},
    {label:'特殊教育教师',value:'特殊教育教师'},
    {label:'其他教学人员',value:'其他教学人员'},
    {label:'文学艺术工作者',value:'文学艺术工作者'},
    {label:'文艺创作和评论人员',value:'文艺创作和评论人员'},
    {label:'编导和音乐指挥人员',value:'编导和音乐指挥人员'},
    {label:'演员',value:'演员'},
    {label:'乐器演奏员',value:'乐器演奏员'},
    // {label:'影视制作及舞台专业人员',value:'影视制作及舞台专业人员'},
    {label:'美术专业人员',value:'美术专业人员'},
    // {label:'工美装饰服装广告设计人员',value:'工美装饰服装广告设计人员'},
    {label:'装璜美术设计人员',value:'装璜美术设计人员'},
    {label:'服装设计师',value:'服装设计师'},
    {label:'室内装饰设计人员',value:'室内装饰设计人员'},
    {label:'广告设计人员',value:'广告设计人员'},
    {label:'其他文学艺术工作者',value:'其他文学艺术工作者'},
    {label:'体育工作者',value:'体育工作者'},
    {label:'体育工作者',value:'体育工作者'},
    {label:'新闻出版文化工作者',value:'新闻出版文化工作者'},
    {label:'记者',value:'记者'},
    {label:'编辑',value:'编辑'},
    {label:'播音员及节目主持人',value:'播音员及节目主持人'},
    {label:'翻译',value:'翻译'},
    {label:'图书资料档案业务人员',value:'图书资料档案业务人员'},
    // {label:'其他新闻出版、文化工作者',value:'其他新闻出版、文化工作者'},
    {label:'办事人员',value:'办事人员'},
    {label:'行政办公人员',value:'行政办公人员'},
    {label:'行政业务人员',value:'行政业务人员'},
    {label:'秘书、打字员',value:'秘书、打字员'},
    {label:'其他行政办公人员',value:'其他行政办公人员'},
    {label:'安全保卫和消防人员',value:'安全保卫和消防人员'},
    {label:'治安保卫人员',value:'治安保卫人员'},
    {label:'其他安全保卫消防人员',value:'其他安全保卫消防人员'},
    {label:'邮政电信业务人员',value:'邮政电信业务人员'},
    {label:'邮政业务人员',value:'邮政业务人员'},
    {label:'电信业务人员、话务员',value:'电信业务人员、话务员'},
    {label:'电信通信传输业务人员',value:'电信通信传输业务人员'},
    {label:'其他邮政电信业务人员',value:'其他邮政电信业务人员'},
    {label:'商业、服务业人员',value:'商业、服务业人员'},
    {label:'购销人员',value:'购销人员'},
    {label:'营业人员、收银员',value:'营业人员、收银员'},
    {label:'推销展销人员',value:'推销展销人员'},
    {label:'采购人员',value:'采购人员'},
    {label:'废旧物资回收利用人员',value:'废旧物资回收利用人员'},
    {label:'商品监督和市场管理员',value:'商品监督和市场管理员'},
    {label:'医药商品购销员',value:'医药商品购销员'},
    {label:'其他购销人员',value:'其他购销人员'},
    {label:'仓储人员',value:'仓储人员'},
    {label:'保管人员',value:'保管人员'},
    {label:'储运人员',value:'储运人员'},
    {label:'其他仓储人员',value:'其他仓储人员'},
    {label:'餐饮服务人员',value:'餐饮服务人员'},
    {label:'中餐烹饪人员',value:'中餐烹饪人员'},
    {label:'西餐烹饪人员',value:'西餐烹饪人员'},
    {label:'调酒和茶艺人员',value:'调酒和茶艺人员'},
    {label:'餐厅服务员、厨工',value:'餐厅服务员、厨工'},
    {label:'其他餐饮服务人员',value:'其他餐饮服务人员'},
    {label:'饭店、旅游娱乐服务员',value:'饭店、旅游娱乐服务员'},
    {label:'饭店服务人员',value:'饭店服务人员'},
    {label:'旅游游览场所服务员',value:'旅游游览场所服务员'},
    {label:'健身娱乐场所服务员',value:'健身娱乐场所服务员'},
    // {label:'其他旅游健身娱乐服务人员',value:'其他旅游健身娱乐服务人员'},
    {label:'运输服务人员',value:'运输服务人员'},
    {label:'公路运输服务人员',value:'公路运输服务人员'},
    {label:'铁路运输服务人员',value:'铁路运输服务人员'},
    {label:'航空运输服务人员',value:'航空运输服务人员'},
    {label:'水上运输服务人员',value:'水上运输服务人员'},
    {label:'其他运输服务人员',value:'其他运输服务人员'},
    {label:'医疗卫生辅助服务人员',value:'医疗卫生辅助服务人员'},
    {label:'护理人员',value:'护理人员'},
    // {label:'其他医疗卫生辅助服务人员',value:'其他医疗卫生辅助服务人员'},
    {label:'社会服务人员',value:'社会服务人员'},
    {label:'社会中介服务人员',value:'社会中介服务人员'},
    {label:'物业管理人员',value:'物业管理人员'},
    {label:'供水供热人员、锅炉工',value:'供水供热人员、锅炉工'},
    {label:'美发美容人员',value:'美发美容人员'},
    {label:'摄影服务人员',value:'摄影服务人员'},
    {label:'验光配镜人员',value:'验光配镜人员'},
    {label:'洗染、织补人员',value:'洗染、织补人员'},
    {label:'浴池服务人员',value:'浴池服务人员'},
    {label:'家用机电产品维修人员',value:'家用机电产品维修人员'},
    {label:'办公设备维修人员',value:'办公设备维修人员'},
    {label:'保育、家庭服务员',value:'保育、家庭服务员'},
    {label:'清洁工',value:'清洁工'},
    {label:'家庭教师',value:'家庭教师'},
    {label:'电梯工',value:'电梯工'},
    {label:'其他社会服务人员',value:'其他社会服务人员'},
    {label:'农林牧渔水利生产人员',value:'农林牧渔水利生产人员'},
    {label:'种植业生产人员',value:'种植业生产人员'},
    {label:'大田作物生产人员',value:'大田作物生产人员'},
    {label:'农业实验人员',value:'农业实验人员'},
    {label:'园艺作物生产人员',value:'园艺作物生产人员'},
    {label:'中药材生产人员',value:'中药材生产人员'},
    {label:'农副林特产品加工工',value:'农副林特产品加工工'},
    {label:'其他种植业生产人员',value:'其他种植业生产人员'},
    {label:'林业及动植物保护人员',value:'林业及动植物保护人员'},
    {label:'木材采运人员',value:'木材采运人员'},
    // {label:'其他林业及野生动植物保护人员',value:'其他林业及野生动植物保护人员'},
    {label:'畜牧业生产人员',value:'畜牧业生产人员'},
    {label:'畜牧业生产人员',value:'畜牧业生产人员'},
    {label:'渔业生产人员',value:'渔业生产人员'},
    {label:'水产养殖人员',value:'水产养殖人员'},
    {label:'水产捕捞及有关人员',value:'水产捕捞及有关人员'},
    {label:'水产品加工工',value:'水产品加工工'},
    {label:'其他渔业生产人员',value:'其他渔业生产人员'},
    {label:'水利设施管理养护人员',value:'水利设施管理养护人员'},
    {label:'水利设施管理养护人员',value:'水利设施管理养护人员'},
    // {label:'农林机械操作和能源开发人员',value:'农林机械操作和能源开发人员'},
    {label:'生产运输工人',value:'生产运输工人'},
    {label:'勘测及矿物开采工',value:'勘测及矿物开采工'},
    {label:'地质勘查人员',value:'地质勘查人员'},
    {label:'测绘人员',value:'测绘人员'},
    {label:'矿物开采工',value:'矿物开采工'},
    {label:'矿物处理工',value:'矿物处理工'},
    {label:'钻井人员',value:'钻井人员'},
    {label:'石油、天然气开采人员',value:'石油、天然气开采人员'},
    {label:'盐业生产人员',value:'盐业生产人员'},
    {label:'其他勘测及矿物开采工',value:'其他勘测及矿物开采工'},
    {label:'金属冶炼轧制工',value:'金属冶炼轧制工'},
    {label:'金属冶炼工',value:'金属冶炼工'},
    {label:'金属轧制工',value:'金属轧制工'},
    {label:'其他金属冶炼、轧制工',value:'其他金属冶炼、轧制工'},
    {label:'化工产品生产工',value:'化工产品生产工'},
    {label:'化工产品生产工',value:'化工产品生产工'},
    {label:'机械制造加工工',value:'机械制造加工工'},
    {label:'机械冷加工工',value:'机械冷加工工'},
    {label:'车工',value:'车工'},
    {label:'铣工',value:'铣工'},
    {label:'刨插工',value:'刨插工'},
    {label:'磨工',value:'磨工'},
    {label:'镗工',value:'镗工'},
    {label:'钻床工',value:'钻床工'},
    {label:'加工中心操作工',value:'加工中心操作工'},
    {label:'制齿工',value:'制齿工'},
    {label:'机械热加工工',value:'机械热加工工'},
    {label:'铸造工',value:'铸造工'},
    {label:'锻造工',value:'锻造工'},
    {label:'冲压工',value:'冲压工'},
    {label:'焊工',value:'焊工'},
    {label:'金属热处理工',value:'金属热处理工'},
    {label:'特种加工设备操作工',value:'特种加工设备操作工'},
    {label:'冷作钣金加工工',value:'冷作钣金加工工'},
    {label:'工件表面处理加工工',value:'工件表面处理加工工'},
    {label:'磨料磨具制造加工人员',value:'磨料磨具制造加工人员'},
    {label:'其他机械制造加工工',value:'其他机械制造加工工'},
    {label:'机电产品装配工',value:'机电产品装配工'},
    {label:'机械设备装配工',value:'机械设备装配工'},
    {label:'电气电子设备装配工',value:'电气电子设备装配工'},
    {label:'仪器仪表装配工',value:'仪器仪表装配工'},
    {label:'运输车辆装配工',value:'运输车辆装配工'},
    {label:'其他机电产品装配工',value:'其他机电产品装配工'},
    {label:'机械设备修理工',value:'机械设备修理工'},
    {label:'机械设备维修工',value:'机械设备维修工'},
    {label:'仪器仪表修理工',value:'仪器仪表修理工'},
    {label:'其他机械设备修理工',value:'其他机械设备修理工'},
    {label:'电力设备装运检修工',value:'电力设备装运检修工'},
    {label:'电力设备安装工',value:'电力设备安装工'},
    {label:'专业电力设备检修工',value:'专业电力设备检修工'},
    // {label:'普通电力设备检修工、电工',value:'普通电力设备检修工、电工'},
    // {label:'其他电力设备装运、检修及供电工',value:'其他电力设备装运、检修及供电工'},
    {label:'电子元器件制造装调工',value:'电子元器件制造装调工'},
    {label:'电子元件、器件制造工',value:'电子元件、器件制造工'},
    {label:'电子设备装配调试工',value:'电子设备装配调试工'},
    {label:'电子产品维修工',value:'电子产品维修工'},
    // {label:'其他电子元器件与电子设备制造、装调维修工',value:'其他电子元器件与电子设备制造、装调维修工'},
    {label:'橡胶塑料制品生产工',value:'橡胶塑料制品生产工'},
    {label:'橡胶制品生产工',value:'橡胶制品生产工'},
    {label:'塑料制品加工工',value:'塑料制品加工工'},
    // {label:'其他橡胶和塑料制品生产工',value:'其他橡胶和塑料制品生产工'},
    {label:'纺织针织印染工',value:'纺织针织印染工'},
    {label:'纤维预处理人员',value:'纤维预处理人员'},
    {label:'纺纱人员',value:'纺纱人员'},
    {label:'织造人员',value:'织造人员'},
    {label:'针织人员',value:'针织人员'},
    {label:'印染人员',value:'印染人员'},
    {label:'纺织、针织、印染工',value:'纺织、针织、印染工'},
    {label:'裁剪缝纫毛皮革制作工',value:'裁剪缝纫毛皮革制作工'},
    {label:'裁剪缝纫工',value:'裁剪缝纫工'},
    {label:'鞋帽制作工',value:'鞋帽制作工'},
    {label:'皮革、毛皮加工工',value:'皮革、毛皮加工工'},
    {label:'缝纫制品再加工人员',value:'缝纫制品再加工人员'},
    // {label:'其他裁剪缝纫和毛皮革制作工',value:'其他裁剪缝纫和毛皮革制作工'},
    {label:'粮油食品饮料生产工',value:'粮油食品饮料生产工'},
    // {label:'粮油食品饮料生产加工及饲料加工工',value:'粮油食品饮料生产加工及饲料加工工'},
    {label:'烟草制品加工工',value:'烟草制品加工工'},
    {label:'烟草制品加工工',value:'烟草制品加工工'},
    {label:'药品生产制造工',value:'药品生产制造工'},
    {label:'药品生产制造工',value:'药品生产制造工'},
    {label:'木材人造板生产制作工',value:'木材人造板生产制作工'},
    {label:'木材加工制作工',value:'木材加工制作工'},
    // {label:'其他木材加工、人造板生产及木制品制作工',value:'其他木材加工、人造板生产及木制品制作工'},
    {label:'制浆造纸纸制品生产工',value:'制浆造纸纸制品生产工'},
    {label:'纸制品制作工',value:'纸制品制作工'},
    // {label:'其他制浆、造纸和纸制品生产加工工',value:'其他制浆、造纸和纸制品生产加工工'},
    {label:'建筑材料生产加工工',value:'建筑材料生产加工工'},
    {label:'建筑材料生产加工工',value:'建筑材料生产加工工'},
    {label:'玻璃陶瓷搪瓷生产工',value:'玻璃陶瓷搪瓷生产工'},
    {label:'玻璃陶瓷搪瓷生产加工工',value:'玻璃陶瓷搪瓷生产加工工'},
    {label:'广播影视品制作播放人员',value:'广播影视品制作播放人员'},
    {label:'广播影视设备操作人员',value:'广播影视设备操作人员'},
    // {label:'其他广播影视品制作播放及文物保护人员',value:'其他广播影视品制作播放及文物保护人员'},
    {label:'制版印刷人员',value:'制版印刷人员'},
    {label:'制版印刷人员',value:'制版印刷人员'},
    {label:'工艺、美术品制作人员',value:'工艺、美术品制作人员'},
    {label:'工艺、美术品制作人员',value:'工艺、美术品制作人员'},
    {label:'文体用品乐器制作人员',value:'文体用品乐器制作人员'},
    {label:'文体用品乐器制作人员',value:'文体用品乐器制作人员'},
    {label:'建筑和工程施工人员',value:'建筑和工程施工人员'},
    {label:'土石方施工人员',value:'土石方施工人员'},
    {label:'砌筑工',value:'砌筑工'},
    {label:'混凝土工',value:'混凝土工'},
    {label:'钢筋工',value:'钢筋工'},
    {label:'架子工',value:'架子工'},
    {label:'工程防水工',value:'工程防水工'},
    {label:'装饰、装修、油漆工',value:'装饰、装修、油漆工'},
    {label:'筑路、养护、维修人员',value:'筑路、养护、维修人员'},
    // {label:'机械电气工程设备安装工、管工',value:'机械电气工程设备安装工、管工'},
    {label:'电工',value:'电工'},
    {label:'木工',value:'木工'},
    {label:'其他工程施工人员',value:'其他工程施工人员'},
    {label:'驾驶员和运输工人',value:'驾驶员和运输工人'},
    {label:'机动车驾驶员',value:'机动车驾驶员'},
    // {label:'铁路、地铁运输设备操作及有关人员',value:'铁路、地铁运输设备操作及有关人员'},
    {label:'船舶水手',value:'船舶水手'},
    {label:'起重装卸机械操作工',value:'起重装卸机械操作工'},
    {label:'其他运输设备操作人员',value:'其他运输设备操作人员'},
    {label:'环境监测废物处理人员',value:'环境监测废物处理人员'},
    {label:'环境监测废物处理人员',value:'环境监测废物处理人员'},
    {label:'检验、计量人员',value:'检验、计量人员'},
    {label:'检验、计量人员',value:'检验、计量人员'},
    {label:'普通工人',value:'普通工人'},
    {label:'普通工',value:'普通工'},
  ],
  // 国家职业等级
  guojiazhiyedengji:[
    {label:'职业资格一级（高级技师）',value:'职业资格一级（高级技师）'},
    {label:'职业资格二级（技师）',value:'职业资格二级（技师）'},
    {label:'职业资格三级（高级）',value:'职业资格三级（高级）'},
    {label:'职业资格四级（中级）',value:'职业资格四级（中级）'},
    {label:'职业资格五级（初级）',value:'职业资格五级（初级）'},
    {label:'其他',value:'其他'},
    {label:'未填写',value:'未填写'},
  ],
  // 所学专业
  suoxuezhuanye:[
    {label:'哲学',value:'哲学'},
    {label:'哲学类',value:'哲学类'},
    {label:'马克思主义理论类',value:'马克思主义理论类'},
    {label:'经济学',value:'经济学'},
    {label:'经济学类',value:'经济学类'},
    {label:'工商管理类',value:'工商管理类'},
    {label:'法学',value:'法学'},
    {label:'法学类',value:'法学类'},
    {label:'社会学类',value:'社会学类'},
    {label:'政治学类',value:'政治学类'},
    {label:'公安学类',value:'公安学类'},
    {label:'教育学',value:'教育学'},
    {label:'教育学类',value:'教育学类'},
    {label:'思想政治教育类',value:'思想政治教育类'},
    {label:'体育学类',value:'体育学类'},
    {label:'职业技术教育类',value:'职业技术教育类'},
    {label:'文学',value:'文学'},
    {label:'中国语言文学类',value:'中国语言文学类'},
    {label:'外国语言文学类',value:'外国语言文学类'},
    {label:'新闻学类',value:'新闻学类'},
    {label:'艺术类(一)',value:'艺术类(一)'},
    {label:'艺术类(二)',value:'艺术类(二)'},
    {label:'历史学',value:'历史学'},
    {label:'历史学类',value:'历史学类'},
    {label:'图书信息档案学类',value:'图书信息档案学类'},
    {label:'理学',value:'理学'},
    {label:'数学类',value:'数学类'},
    {label:'物理学类',value:'物理学类'},
    {label:'化学类',value:'化学类'},
    {label:'生物科学类',value:'生物科学类'},
    {label:'天文学类',value:'天文学类'},
    {label:'地质学类',value:'地质学类'},
    {label:'地理科学类',value:'地理科学类'},
    {label:'地球物理学类',value:'地球物理学类'},
    {label:'大气科学类',value:'大气科学类'},
    {label:'海洋科学类',value:'海洋科学类'},
    {label:'力学类',value:'力学类'},
    {label:'信息与电子科学类',value:'信息与电子科学类'},
    {label:'材料科学类',value:'材料科学类'},
    {label:'环境科学类',value:'环境科学类'},
    {label:'心理学类',value:'心理学类'},
    {label:'科技信息与管理类',value:'科技信息与管理类'},
    {label:'工学',value:'工学'},
    {label:'地矿类',value:'地矿类'},
    {label:'材料类',value:'材料类'},
    {label:'机械类',value:'机械类'},
    {label:'仪器仪表类',value:'仪器仪表类'},
    {label:'热能核能类',value:'热能核能类'},
    {label:'电工类',value:'电工类'},
    {label:'电子与信息类',value:'电子与信息类'},
    {label:'土建类',value:'土建类'},
    {label:'水利类',value:'水利类'},
    {label:'测绘类',value:'测绘类'},
    {label:'环境类',value:'环境类'},
    {label:'化工与制药类',value:'化工与制药类'},
    {label:'轻工粮食食品类',value:'轻工粮食食品类'},
    {label:'农业工程类',value:'农业工程类'},
    {label:'林业工程类',value:'林业工程类'},
    {label:'纺织类',value:'纺织类'},
    {label:'交通运输类',value:'交通运输类'},
    {label:'航空航天类',value:'航空航天类'},
    {label:'兵器类',value:'兵器类'},
    {label:'公安技术类',value:'公安技术类'},
    {label:'工程力学类',value:'工程力学类'},
    {label:'管理工程类',value:'管理工程类'},
    {label:'农学',value:'农学'},
    {label:'植物生产类',value:'植物生产类'},
    {label:'森林资源类',value:'森林资源类'},
    {label:'环境保护类',value:'环境保护类'},
    {label:'动物生产与兽医类',value:'动物生产与兽医类'},
    {label:'水产类',value:'水产类'},
    {label:'管理类',value:'管理类'},
    {label:'农业推广类',value:'农业推广类'},
    {label:'医学',value:'医学'},
    {label:'基础医学类',value:'基础医学类'},
    {label:'预防医学类',value:'预防医学类'},
    {label:'临床医学与医学技术类',value:'临床医学与医学技术类'},
    {label:'口腔医学类',value:'口腔医学类'},
    {label:'中医学类',value:'中医学类'},
    {label:'法医学类',value:'法医学类'},
    {label:'护理学类',value:'护理学类'},
    {label:'药学类',value:'药学类'},
    {label:'管理类',value:'管理类'},
    {label:'军事学',value:'军事学'},
    {label:'其他学科',value:'其他学科'},
    {label:'未填写',value:'未填写'},
  ],
  // 学历
  xueli:[
    {label:'博士研究生',value:'博士研究生'},
    {label:'硕士研究生',value:'硕士研究生'},
    {label:'大学本科',value:'大学本科'},
    {label:'大学专科',value:'大学专科'},
    {label:'中等专科',value:'中等专科'},
    {label:'职业高中',value:'职业高中'},
    {label:'技工学校',value:'技工学校'},
    {label:'普通高中',value:'普通高中'},
    {label:'初中',value:'初中'},
    {label:'小学',value:'小学'},
    {label:'其他',value:'其他'},
    {label:'无要求',value:'无要求'},
  ],
  // 职称
  zhicheng:[
    {label:'高等学校教师',value:'高等学校教师'},
    {label:'教授',value:'教授'},
    {label:'副教授',value:'副教授'},
    {label:'讲师（高校）',value:'讲师（高校）'},
    {label:'助教（高校）',value:'助教（高校）'},
    {label:'中等专业学校教师',value:'中等专业学校教师'},
    {label:'高级讲师（中专）',value:'高级讲师（中专）'},
    {label:'讲师（中专）',value:'讲师（中专）'},
    {label:'助理讲师（中专）',value:'助理讲师（中专）'},
    {label:'教员（中专）',value:'教员（中专）'},
    {label:'技工学校教师（文化理论）',value:'技工学校教师（文化理论）'},
    {label:'高级讲师（技校）',value:'高级讲师（技校）'},
    {label:'讲师（技校）',value:'讲师（技校）'},
    {label:'助理讲师（技校）',value:'助理讲师（技校）'},
    {label:'教员（技校）',value:'教员（技校）'},
    {label:'技工学校教师（实习指导）',value:'技工学校教师（实习指导）'},
    {label:'高级实习指导教师',value:'高级实习指导教师'},
    {label:'一级实习指导教师',value:'一级实习指导教师'},
    {label:'二级实习指导教师',value:'二级实习指导教师'},
    {label:'三级实习指导教师',value:'三级实习指导教师'},
    {label:'中学教师',value:'中学教师'},
    {label:'高级教师（中学）',value:'高级教师（中学）'},
    {label:'一级教师（中学）',value:'一级教师（中学）'},
    {label:'二级教师（中学）',value:'二级教师（中学）'},
    {label:'三级教师（中学）',value:'三级教师（中学）'},
    {label:'实验技术人员',value:'实验技术人员'},
    {label:'高级实验师',value:'高级实验师'},
    {label:'实验师',value:'实验师'},
    {label:'助理实验师',value:'助理实验师'},
    {label:'实验员',value:'实验员'},
    {label:'工程技术人员',value:'工程技术人员'},
    {label:'高级工程师',value:'高级工程师'},
    {label:'工程师',value:'工程师'},
    {label:'助理工程师',value:'助理工程师'},
    {label:'技术员',value:'技术员'},
    {label:'农业技术人员（农艺）',value:'农业技术人员（农艺）'},
    {label:'农业技术推广研究员（农艺）',value:'农业技术推广研究员（农艺）'},
    {label:'高级农艺师',value:'高级农艺师'},
    {label:'农艺师',value:'农艺师'},
    {label:'助理农艺师',value:'助理农艺师'},
    {label:'农业技术员',value:'农业技术员'},
    {label:'农业技术人员（兽医）',value:'农业技术人员（兽医）'},
    {label:'农业技术推广研究员（兽医）',value:'农业技术推广研究员（兽医）'},
    {label:'高级兽医师',value:'高级兽医师'},
    {label:'兽医师',value:'兽医师'},
    {label:'助理兽医师',value:'助理兽医师'},
    {label:'兽医技术员',value:'兽医技术员'},
    {label:'农业技术人员（畜牧）',value:'农业技术人员（畜牧）'},
    {label:'农业技术推广研究员（畜牧）',value:'农业技术推广研究员（畜牧）'},
    {label:'高级畜牧师',value:'高级畜牧师'},
    {label:'畜牧师',value:'畜牧师'},
    {label:'助理畜牧师',value:'助理畜牧师'},
    {label:'畜牧技术员',value:'畜牧技术员'},
    {label:'经济专业人员',value:'经济专业人员'},
    {label:'高级经济师',value:'高级经济师'},
    {label:'经济师',value:'经济师'},
    {label:'助理经济师',value:'助理经济师'},
    {label:'经济员',value:'经济员'},
    {label:'会计专业人员',value:'会计专业人员'},
    {label:'高级会计师',value:'高级会计师'},
    {label:'会计师',value:'会计师'},
    {label:'助理会计师',value:'助理会计师'},
    {label:'会计员',value:'会计员'},
    {label:'统计专业人员',value:'统计专业人员'},
    {label:'高级统计师',value:'高级统计师'},
    {label:'统计师',value:'统计师'},
    {label:'助理统计师',value:'助理统计师'},
    {label:'统计员',value:'统计员'},
    {label:'出版专业人员（编辑）',value:'出版专业人员（编辑）'},
    {label:'编审',value:'编审'},
    {label:'副编审',value:'副编审'},
    {label:'编辑',value:'编辑'},
    {label:'助理编辑',value:'助理编辑'},
    {label:'出版专业人员（技术编辑）',value:'出版专业人员（技术编辑）'},
    {label:'技术编辑',value:'技术编辑'},
    {label:'助理技术编辑',value:'助理技术编辑'},
    {label:'技术设计员',value:'技术设计员'},
    {label:'出版专业人员（校对）',value:'出版专业人员（校对）'},
    {label:'一级校对',value:'一级校对'},
    {label:'二级校对',value:'二级校对'},
    {label:'三级校对',value:'三级校对'},
    {label:'翻译人员',value:'翻译人员'},
    {label:'译审（资深翻译）',value:'译审（资深翻译）'},
    {label:'副译审（一级翻译）',value:'副译审（一级翻译）'},
    {label:'翻译',value:'翻译'},
    {label:'助理翻译',value:'助理翻译'},
    {label:'新闻专业人员（记者）',value:'新闻专业人员（记者）'},
    {label:'高级记者',value:'高级记者'},
    {label:'主任记者',value:'主任记者'},
    {label:'记者',value:'记者'},
    {label:'助理记者',value:'助理记者'},
    {label:'新闻专业人员（编辑）',value:'新闻专业人员（编辑）'},
    {label:'高级编辑',value:'高级编辑'},
    {label:'主任编辑',value:'主任编辑'},
    {label:'编辑',value:'编辑'},
    {label:'助理编辑',value:'助理编辑'},
    {label:'广播电视播音员',value:'广播电视播音员'},
    {label:'播音指导',value:'播音指导'},
    {label:'主任播音员',value:'主任播音员'},
    {label:'一级播音员',value:'一级播音员'},
    {label:'二级播音员',value:'二级播音员'},
    {label:'三级播音员',value:'三级播音员'},
    {label:'卫生技术人员（医师）',value:'卫生技术人员（医师）'},
    {label:'主任医师',value:'主任医师'},
    {label:'副主任医师',value:'副主任医师'},
    {label:'主治（主管）医师',value:'主治（主管）医师'},
    {label:'医师',value:'医师'},
    {label:'医士',value:'医士'},
    {label:'卫生技术人员（药剂）',value:'卫生技术人员（药剂）'},
    {label:'主任药师',value:'主任药师'},
    {label:'副主任药师',value:'副主任药师'},
    {label:'主管药师',value:'主管药师'},
    {label:'药师',value:'药师'},
    {label:'药士',value:'药士'},
    {label:'卫生技术人员（护理）',value:'卫生技术人员（护理）'},
    {label:'主任护师',value:'主任护师'},
    {label:'副主任护师',value:'副主任护师'},
    {label:'主管护师',value:'主管护师'},
    {label:'护师',value:'护师'},
    {label:'护士',value:'护士'},
    {label:'卫生技术人员（技师）',value:'卫生技术人员（技师）'},
    {label:'主任技师',value:'主任技师'},
    {label:'副主任技师',value:'副主任技师'},
    {label:'主管技师',value:'主管技师'},
    {label:'技师',value:'技师'},
    {label:'技士',value:'技士'},
    {label:'工艺美术专业人员',value:'工艺美术专业人员'},
    {label:'高级工艺美术师',value:'高级工艺美术师'},
    {label:'工艺美术师',value:'工艺美术师'},
    {label:'助理工艺美术师',value:'助理工艺美术师'},
    {label:'工艺美术员',value:'工艺美术员'},
    {label:'艺术人员（演员）',value:'艺术人员（演员）'},
    {label:'一级演员',value:'一级演员'},
    {label:'二级演员',value:'二级演员'},
    {label:'三级演员',value:'三级演员'},
    {label:'四级演员',value:'四级演员'},
    {label:'艺术人员（演奏员）',value:'艺术人员（演奏员）'},
    {label:'一级演奏员',value:'一级演奏员'},
    {label:'二级演奏员',value:'二级演奏员'},
    {label:'三级演奏员',value:'三级演奏员'},
    {label:'四级演奏员',value:'四级演奏员'},
    {label:'艺术人员（编剧）',value:'艺术人员（编剧）'},
    {label:'一级编剧',value:'一级编剧'},
    {label:'二级编剧',value:'二级编剧'},
    {label:'三级编剧',value:'三级编剧'},
    {label:'四级编剧',value:'四级编剧'},
    {label:'艺术人员（导演）',value:'艺术人员（导演）'},
    {label:'一级导演',value:'一级导演'},
    {label:'二级导演',value:'二级导演'},
    {label:'三级导演',value:'三级导演'},
    {label:'四级导演',value:'四级导演'},
    {label:'艺术人员（指挥）',value:'艺术人员（指挥）'},
    {label:'一级指挥',value:'一级指挥'},
    {label:'二级指挥',value:'二级指挥'},
    {label:'三级指挥',value:'三级指挥'},
    {label:'四级指挥',value:'四级指挥'},
    {label:'艺术人员（作曲）',value:'艺术人员（作曲）'},
    {label:'一级作曲',value:'一级作曲'},
    {label:'二级作曲',value:'二级作曲'},
    {label:'三级作曲',value:'三级作曲'},
    {label:'四级作曲',value:'四级作曲'},
    {label:'艺术人员（美术）',value:'艺术人员（美术）'},
    {label:'一级美术师',value:'一级美术师'},
    {label:'二级美术师',value:'二级美术师'},
    {label:'三级美术师',value:'三级美术师'},
    {label:'美术员',value:'美术员'},
    {label:'艺术人员（舞美设计）',value:'艺术人员（舞美设计）'},
    {label:'一级舞美设计师',value:'一级舞美设计师'},
    {label:'二级舞美设计师',value:'二级舞美设计师'},
    {label:'三级舞美设计师',value:'三级舞美设计师'},
    {label:'四级舞美设计员',value:'四级舞美设计员'},
    {label:'艺术人员（舞台设计）',value:'艺术人员（舞台设计）'},
    {label:'主任舞台技师',value:'主任舞台技师'},
    {label:'舞台技师',value:'舞台技师'},
    {label:'舞台技术员',value:'舞台技术员'},
    {label:'教练员',value:'教练员'},
    {label:'国家级教练',value:'国家级教练'},
    {label:'高级教练',value:'高级教练'},
    {label:'教练',value:'教练'},
    {label:'助理教练',value:'助理教练'},
    {label:'律师',value:'律师'},
    {label:'一级律师',value:'一级律师'},
    {label:'二级律师',value:'二级律师'},
    {label:'三级律师',value:'三级律师'},
    {label:'四级律师',value:'四级律师'},
    {label:'律师助理',value:'律师助理'},
    {label:'公证员',value:'公证员'},
    {label:'一级公证员',value:'一级公证员'},
    {label:'二级公证员',value:'二级公证员'},
    {label:'三级公证员',value:'三级公证员'},
    {label:'四级公证员',value:'四级公证员'},
    {label:'公证助理员',value:'公证助理员'},
    {label:'小学（幼儿园）教师',value:'小学（幼儿园）教师'},
    {label:'高级教师（小学）',value:'高级教师（小学）'},
    {label:'一级教师（小学）',value:'一级教师（小学）'},
    {label:'二级教师（小学）',value:'二级教师（小学）'},
    {label:'三级教师（小学）',value:'三级教师（小学）'},
    {label:'船舶技术人员（驾驶）',value:'船舶技术人员（驾驶）'},
    {label:'高级船长',value:'高级船长'},
    {label:'船长（大副）',value:'船长（大副）'},
    {label:'二副',value:'二副'},
    {label:'三副',value:'三副'},
    {label:'船舶技术人员（轮机）',value:'船舶技术人员（轮机）'},
    {label:'高级轮机长',value:'高级轮机长'},
    {label:'轮机长（大管轮）',value:'轮机长（大管轮）'},
    {label:'二管轮',value:'二管轮'},
    {label:'三管轮',value:'三管轮'},
    {label:'船舶技术人员（电机）',value:'船舶技术人员（电机）'},
    {label:'高级电机员',value:'高级电机员'},
    {label:'通用电机员（一等电机员）',value:'通用电机员（一等电机员）'},
    {label:'二等电机员',value:'二等电机员'},
    {label:'船舶技术人员（报务）',value:'船舶技术人员（报务）'},
    {label:'高级报务员',value:'高级报务员'},
    {label:'通用报务员',value:'通用报务员'},
    {label:'二等报务员',value:'二等报务员'},
    {label:'限用报务员',value:'限用报务员'},
    {label:'飞行技术人员（驾驶）',value:'飞行技术人员（驾驶）'},
    {label:'一级飞行员',value:'一级飞行员'},
    {label:'二级飞行员',value:'二级飞行员'},
    {label:'三级飞行员',value:'三级飞行员'},
    {label:'四级飞行员',value:'四级飞行员'},
    {label:'飞行技术人员（领航）',value:'飞行技术人员（领航）'},
    {label:'一级领航员',value:'一级领航员'},
    {label:'二级领航员',value:'二级领航员'},
    {label:'三级领航员',value:'三级领航员'},
    {label:'四级领航员',value:'四级领航员'},
    {label:'飞行技术人员（通信）',value:'飞行技术人员（通信）'},
    {label:'一级飞行通信员',value:'一级飞行通信员'},
    {label:'二级飞行通信员',value:'二级飞行通信员'},
    {label:'三级飞行通信员',value:'三级飞行通信员'},
    {label:'四级飞行通信员',value:'四级飞行通信员'},
    {label:'飞行技术人员（机械）',value:'飞行技术人员（机械）'},
    {label:'一级飞行机械员',value:'一级飞行机械员'},
    {label:'二级飞行机械员',value:'二级飞行机械员'},
    {label:'三级飞行机械员',value:'三级飞行机械员'},
    {label:'四级飞行机械员',value:'四级飞行机械员'},
    {label:'自然科学研究人员',value:'自然科学研究人员'},
    {label:'研究员（自然科学）',value:'研究员（自然科学）'},
    {label:'副研究员（自然科学）',value:'副研究员（自然科学）'},
    {label:'助理研究员（自然科学）',value:'助理研究员（自然科学）'},
    {label:'研究实习员（自然科学）',value:'研究实习员（自然科学）'},
    {label:'社会科学研究人员',value:'社会科学研究人员'},
    {label:'研究员（社会科学）',value:'研究员（社会科学）'},
    {label:'副研究员（社会科学）',value:'副研究员（社会科学）'},
    {label:'助理研究员（社会科学）',value:'助理研究员（社会科学）'},
    {label:'研究实习员（社会科学）',value:'研究实习员（社会科学）'},
    {label:'图书、资料专业人员',value:'图书、资料专业人员'},
    {label:'研究馆员（图书）',value:'研究馆员（图书）'},
    {label:'副研究馆员（图书）',value:'副研究馆员（图书）'},
    {label:'馆员（图书）',value:'馆员（图书）'},
    {label:'助理馆员（图书）',value:'助理馆员（图书）'},
    {label:'管理员（图书）',value:'管理员（图书）'},
    {label:'文博专业人员',value:'文博专业人员'},
    {label:'研究馆员（文博）',value:'研究馆员（文博）'},
    {label:'副研究馆员（文博）',value:'副研究馆员（文博）'},
    {label:'馆员（文博）',value:'馆员（文博）'},
    {label:'助理馆员（文博）',value:'助理馆员（文博）'},
    {label:'管理员（文博）',value:'管理员（文博）'},
    {label:'档案专业人员',value:'档案专业人员'},
    {label:'研究馆员（档案）',value:'研究馆员（档案）'},
    {label:'副研究馆员（档案）',value:'副研究馆员（档案）'},
    {label:'馆员（档案）',value:'馆员（档案）'},
    {label:'助理馆员（档案）',value:'助理馆员（档案）'},
    {label:'管理员（档案）',value:'管理员（档案）'},
    {label:'其他',value:'其他'},
    {label:'未填写',value:'未填写'},
  ],
  // 工作环境
  gongzuohuanjing:[
    {label:'室内',value:'室内'},
    {label:'室外',value:'室外'},
    {label:'其他',value:'其他'},
    {label:'未填写)',value:'未填写)'},
  ],
  // 工作性质
  gongzuoxingzhi:[
    {label:'全职',value:'全职'},
    {label:'兼职',value:'兼职'},
    {label:'实习',value:'实习'},
    {label:'临时',value:'临时'},
    {label:'小时工',value:'小时工'},
    {label:'均可',value:'均可'},
    {label:'其他',value:'其他'},
  ],
  // 政治面貌
  zhengzhimianmao:[
    {label:'中共党员',value:'中共党员'},
    {label:'中共预备党员',value:'中共预备党员'},
    {label:'共青团员',value:'共青团员'},
    {label:'民革会员',value:'民革会员'},
    {label:'民盟盟员',value:'民盟盟员'},
    {label:'民建会员',value:'民建会员'},
    {label:'民进会员',value:'民进会员'},
    {label:'农工党党员',value:'农工党党员'},
    {label:'致公党党员',value:'致公党党员'},
    {label:'九三学社社员',value:'九三学社社员'},
    {label:'台盟盟员',value:'台盟盟员'},
    {label:'无党派民主人士',value:'无党派民主人士'},
    {label:'群众',value:'群众'},
  ],
  // 外语语种
  yuzhong:[
    {label:'阿法尔语',value:'阿法尔语'},
    {label:'阿布哈兹语',value:'阿布哈兹语'},
    {label:'阿维斯陀语',value:'阿维斯陀语'},
    {label:'阿非利堪斯语',value:'阿非利堪斯语'},
    {label:'阿坎语',value:'阿坎语'},
    {label:'阿姆哈拉语',value:'阿姆哈拉语'},
    {label:'阿拉伯语',value:'阿拉伯语'},
    {label:'阿萨姆语',value:'阿萨姆语'},
    {label:'阿瓦尔语',value:'阿瓦尔语'},
    {label:'艾马拉语',value:'艾马拉语'},
    {label:'阿塞拜疆语',value:'阿塞拜疆语'},
    {label:'巴什基尔语',value:'巴什基尔语'},
    {label:'白俄罗斯语',value:'白俄罗斯语'},
    {label:'保加利亚语',value:'保加利亚语'},
    {label:'比哈尔语',value:'比哈尔语'},
    {label:'比斯拉玛语',value:'比斯拉玛语'},
    {label:'班巴拉语',value:'班巴拉语'},
    {label:'孟加拉语',value:'孟加拉语'},
    {label:'藏语',value:'藏语'},
    {label:'布列塔尼语',value:'布列塔尼语'},
    {label:'波斯尼亚语',value:'波斯尼亚语'},
    {label:'加泰隆语',value:'加泰隆语'},
    {label:'车臣语',value:'车臣语'},
    {label:'查莫罗语',value:'查莫罗语'},
    {label:'科西嘉语',value:'科西嘉语'},
    {label:'克里语',value:'克里语'},
    {label:'捷克语',value:'捷克语'},
    {label:'教会斯拉夫语',value:'教会斯拉夫语'},
    {label:'楚瓦什语',value:'楚瓦什语'},
    {label:'威尔士语',value:'威尔士语'},
    {label:'丹麦语',value:'丹麦语'},
    {label:'德语',value:'德语'},
    {label:'马尔代夫语/迪维希语',value:'马尔代夫语/迪维希语'},
    {label:'不丹语',value:'不丹语'},
    {label:'埃维语',value:'埃维语'},
    {label:'现代希腊语(公元1453年以后)',value:'现代希腊语(公元1453年以后)'},
    {label:'英语',value:'英语'},
    {label:'世界语',value:'世界语'},
    {label:'西班牙语',value:'西班牙语'},
    {label:'爱沙尼亚语',value:'爱沙尼亚语'},
    {label:'巴斯克语',value:'巴斯克语'},
    {label:'波斯语',value:'波斯语'},
    {label:'颇尔语/富拉语',value:'颇尔语/富拉语'},
    {label:'芬兰语',value:'芬兰语'},
    {label:'斐济语',value:'斐济语'},
    {label:'法罗斯语',value:'法罗斯语'},
    {label:'法语',value:'法语'},
    {label:'弗里西亚语',value:'弗里西亚语'},
    {label:'爱尔兰语',value:'爱尔兰语'},
    {label:'苏格兰语/盖尔语（苏格兰）',value:'苏格兰语/盖尔语（苏格兰）'},
    {label:'加利西亚语',value:'加利西亚语'},
    {label:'瓜拉尼语',value:'瓜拉尼语'},
    {label:'古吉拉特语',value:'古吉拉特语'},
    {label:'马恩岛语',value:'马恩岛语'},
    {label:'豪萨语',value:'豪萨语'},
    {label:'希伯来语',value:'希伯来语'},
    {label:'印地语',value:'印地语'},
    {label:'希里莫图语',value:'希里莫图语'},
    {label:'克罗地亚语',value:'克罗地亚语'},
    {label:'匈牙利语',value:'匈牙利语'},
    {label:'亚美尼亚语',value:'亚美尼亚语'},
    {label:'赫雷罗语',value:'赫雷罗语'},
    {label:'国际语A',value:'国际语A'},
    {label:'印尼语',value:'印尼语'},
    {label:'国际语E',value:'国际语E'},
    {label:'伊博语',value:'伊博语'},
    {label:'依努庇克语',value:'依努庇克语'},
    {label:'伊多语',value:'伊多语'},
    {label:'冰岛语',value:'冰岛语'},
    {label:'意大利语',value:'意大利语'},
    {label:'伊努伊特语',value:'伊努伊特语'},
    {label:'日语',value:'日语'},
    {label:'爪哇语',value:'爪哇语'},
    {label:'格鲁吉亚语',value:'格鲁吉亚语'},
    {label:'刚果语',value:'刚果语'},
    {label:'基库尤语',value:'基库尤语'},
    {label:'夸尼亚码语',value:'夸尼亚码语'},
    {label:'哈萨克语',value:'哈萨克语'},
    {label:'格陵兰语',value:'格陵兰语'},
    {label:'柬埔寨语/高棉语',value:'柬埔寨语/高棉语'},
    {label:'坎纳达语',value:'坎纳达语'},
    {label:'朝鲜语',value:'朝鲜语'},
    {label:'卡努里语',value:'卡努里语'},
    {label:'克什米尔语',value:'克什米尔语'},
    {label:'库尔德语',value:'库尔德语'},
    {label:'科米语',value:'科米语'},
    {label:'康沃尔语',value:'康沃尔语'},
    {label:'吉尔吉斯语',value:'吉尔吉斯语'},
    {label:'拉丁语',value:'拉丁语'},
    {label:'卢森堡语',value:'卢森堡语'},
    {label:'干达语',value:'干达语'},
    {label:'林加拉语',value:'林加拉语'},
    {label:'老挝语',value:'老挝语'},
    {label:'立陶宛语',value:'立陶宛语'},
    {label:'卢巴—加丹加语',value:'卢巴—加丹加语'},
    {label:'拉脱维亚语',value:'拉脱维亚语'},
    {label:'马达加斯加语',value:'马达加斯加语'},
    {label:'马绍尔语',value:'马绍尔语'},
    {label:'毛利语',value:'毛利语'},
    {label:'马其顿语',value:'马其顿语'},
    {label:'马拉亚拉姆语',value:'马拉亚拉姆语'},
    {label:'蒙古语',value:'蒙古语'},
    {label:'摩尔达维亚语',value:'摩尔达维亚语'},
    {label:'马拉提语',value:'马拉提语'},
    {label:'马来语',value:'马来语'},
    {label:'马耳他语',value:'马耳他语'},
    {label:'缅甸语',value:'缅甸语'},
    {label:'瑙鲁语',value:'瑙鲁语'},
    {label:'挪威布克摩尔语',value:'挪威布克摩尔语'},
    {label:'北恩德贝勒语',value:'北恩德贝勒语'},
    {label:'尼泊尔语',value:'尼泊尔语'},
    {label:'恩敦加语',value:'恩敦加语'},
    {label:'荷兰语',value:'荷兰语'},
    {label:'尼诺斯克挪威语',value:'尼诺斯克挪威语'},
    {label:'挪威语',value:'挪威语'},
    {label:'南恩德贝勒语',value:'南恩德贝勒语'},
    {label:'纳瓦霍语',value:'纳瓦霍语'},
    {label:'班图语/尼扬贾语',value:'班图语/尼扬贾语'},
    {label:'奥吉西唐语（公元1500年以后）/普罗旺斯语(公元1500年以后)',value:'奥吉西唐语（公元1500年以后）/普罗旺斯语(公元1500年以后)'},
    {label:'奥吉布瓦语',value:'奥吉布瓦语'},
    {label:'库希特语/阿芳·奥洛莫语',value:'库希特语/阿芳·奥洛莫语'},
    {label:'奥利亚语',value:'奥利亚语'},
    {label:'奥塞梯语',value:'奥塞梯语'},
    {label:'旁遮普语',value:'旁遮普语'},
    {label:'巴利语',value:'巴利语'},
    {label:'波兰语',value:'波兰语'},
    {label:'普什图语',value:'普什图语'},
    {label:'葡萄牙语',value:'葡萄牙语'},
    {label:'凯楚亚语',value:'凯楚亚语'},
    {label:'利托-罗曼语',value:'利托-罗曼语'},
    {label:'基隆迪语',value:'基隆迪语'},
    {label:'曼尼普尔语',value:'曼尼普尔语'},
    {label:'俄语',value:'俄语'},
    {label:'卢旺达语/基尼阿万达语',value:'卢旺达语/基尼阿万达语'},
    {label:'梵语',value:'梵语'},
    {label:'撒丁语',value:'撒丁语'},
    {label:'信德语',value:'信德语'},
    {label:'北萨摩斯语',value:'北萨摩斯语'},
    {label:'桑戈语',value:'桑戈语'},
    {label:'塞尔维亚--克罗地亚语',value:'塞尔维亚--克罗地亚语'},
    {label:'僧加罗语',value:'僧加罗语'},
    {label:'斯洛伐克语',value:'斯洛伐克语'},
    {label:'斯洛文尼亚语',value:'斯洛文尼亚语'},
    {label:'萨摩亚语',value:'萨摩亚语'},
    {label:'绍纳语',value:'绍纳语'},
    {label:'索马里语',value:'索马里语'},
    {label:'阿尔巴尼亚语',value:'阿尔巴尼亚语'},
    {label:'塞尔维亚语',value:'塞尔维亚语'},
    {label:'塞斯瓦特语',value:'塞斯瓦特语'},
    {label:'南索托语',value:'南索托语'},
    {label:'巽他语',value:'巽他语'},
    {label:'瑞典语',value:'瑞典语'},
    {label:'斯瓦希里语',value:'斯瓦希里语'},
    {label:'泰米尔语',value:'泰米尔语'},
    {label:'泰卢固语',value:'泰卢固语'},
    {label:'塔吉克语',value:'塔吉克语'},
    {label:'泰语',value:'泰语'},
    {label:'提格里尼亚语',value:'提格里尼亚语'},
    {label:'土库曼语',value:'土库曼语'},
    {label:'他加禄语',value:'他加禄语'},
    {label:'茨瓦纳语/塞茨瓦纳语',value:'茨瓦纳语/塞茨瓦纳语'},
    {label:'汤加语(汤加岛)',value:'汤加语(汤加岛)'},
    {label:'土耳其语',value:'土耳其语'},
    {label:'宗加语',value:'宗加语'},
    {label:'塔塔尔语',value:'塔塔尔语'},
    {label:'特威语',value:'特威语'},
    {label:'塔希提语',value:'塔希提语'},
    {label:'维吾尔语',value:'维吾尔语'},
    {label:'乌克兰语',value:'乌克兰语'},
    {label:'乌尔都语',value:'乌尔都语'},
    {label:'乌兹别克语',value:'乌兹别克语'},
    {label:'文达语',value:'文达语'},
    {label:'越南语',value:'越南语'},
    {label:'沃拉普克语',value:'沃拉普克语'},
    {label:'瓦隆语',value:'瓦隆语'},
    {label:'沃洛夫语',value:'沃洛夫语'},
    {label:'科萨语',value:'科萨语'},
    {label:'依地语',value:'依地语'},
    {label:'约鲁巴语',value:'约鲁巴语'},
    {label:'状语',value:'状语'},
    {label:'汉语(中文)',value:'汉语(中文)'},
    {label:'祖鲁语',value:'祖鲁语'},
    {label:'其他语言',value:'其他语言'},
    {label:'印尼语',value:'印尼语'},
    {label:'英语',value:'英语'},
    {label:'约鲁巴语',value:'约鲁巴语'},
    {label:'越南语',value:'越南语'},
    {label:'藏语',value:'藏语'},
    {label:'爪哇语',value:'爪哇语'},
    {label:'状语',value:'状语'},
    {label:'宗加语',value:'宗加语'},
    {label:'祖鲁语',value:'祖鲁语'},
  ],
  // 外语水平 计算机水平
  shuiping:[
    {label:'精通',value:'精通'},
    {label:'熟练',value:'熟练'},
    {label:'良好',value:'良好'},
    {label:'一般',value:'一般'},
    {label:'其他',value:'其他'},
    {label:'未填写',value:'未填写'},
  ],
  // 试用期月工资档次
  gongzidangci:[
    {label:'1000以下',value:'1000以下'},
    {label:'1000-1999',value:'1000-1999'},
    {label:'2000-2999',value:'2000-2999'},
    {label:'3000-3999',value:'3000-3999'},
    {label:'4000-4999',value:'4000-4999'},
    {label:'5000及以上',value:'5000及以上'},
    {label:'其他',value:'其他'},
  ],
  // 提供住宿标识 提供住房公积金标识
  shifouqita:[
    {label:'否',value:'否'},
    {label:'是',value:'是'},
    {label:'其他',value:'其他'},
  ],
  // 发布状态 公开联系方式标识 招聘岗位审核标识
  shifou:[
    {label:'否',value:'否'},
    {label:'是',value:'是'},
  ],
  // 审核状态
  shenhezhuangtai:[
    {label:'审核通过',value:'审核通过'},
    {label:'审核不通过',value:'审核不通过'},
    {label:'待审核',value:'待审核'},
  ],
  // 数据更新标识
  gengxinbiaoshi:[
    {label:'新增',value:'新增'},
    {label:'更新',value:'更新'},
    {label:'删除',value:'删除'},
  ],
  // 所属行业
  suoshuhangye:[
    {label:'农、林、牧、渔业',value:'农、林、牧、渔业'},
    {label:'农业',value:'农业'},
    {label:'林业',value:'林业'},
    {label:'畜牧业',value:'畜牧业'},
    {label:'渔业',value:'渔业'},
    {label:'农、林、牧、渔服务业',value:'农、林、牧、渔服务业'},
    {label:'采矿业',value:'采矿业'},
    {label:'煤炭开采和洗选业',value:'煤炭开采和洗选业'},
    {label:'石油和天然气开采业',value:'石油和天然气开采业'},
    {label:'黑色金属矿采选业',value:'黑色金属矿采选业'},
    {label:'有色金属矿采选业',value:'有色金属矿采选业'},
    {label:'非金属矿采选业',value:'非金属矿采选业'},
    {label:'其他采矿业',value:'其他采矿业'},
    {label:'制造业',value:'制造业'},
    {label:'农副食品加工业',value:'农副食品加工业'},
    {label:'食品制造业',value:'食品制造业'},
    {label:'饮料制造业',value:'饮料制造业'},
    {label:'烟草制品业',value:'烟草制品业'},
    {label:'纺织业',value:'纺织业'},
    {label:'纺织服装、鞋、帽制造业',value:'纺织服装、鞋、帽制造业'},
    {label:'皮革、毛皮、羽毛(绒)及其制品业',value:'皮革、毛皮、羽毛(绒)及其制品业'},
    {label:'木材加工及木、竹、藤、棕、草制品业',value:'木材加工及木、竹、藤、棕、草制品业'},
    {label:'家具制造业',value:'家具制造业'},
    {label:'造纸及纸制品业',value:'造纸及纸制品业'},
    {label:'印刷业和记录媒介的复制',value:'印刷业和记录媒介的复制'},
    {label:'文教体育用品制造业',value:'文教体育用品制造业'},
    {label:'石油加工、炼焦及核燃料加工业',value:'石油加工、炼焦及核燃料加工业'},
    {label:'化学原料及化学制品制造业',value:'化学原料及化学制品制造业'},
    {label:'医药制造业',value:'医药制造业'},
    {label:'化学纤维制造业',value:'化学纤维制造业'},
    {label:'橡胶制品业',value:'橡胶制品业'},
    {label:'塑料制品业',value:'塑料制品业'},
    {label:'非金属矿物制品业',value:'非金属矿物制品业'},
    {label:'黑色金属冶炼及压延加工业',value:'黑色金属冶炼及压延加工业'},
    {label:'有色金属冶炼及压延加工业',value:'有色金属冶炼及压延加工业'},
    {label:'金属制品业',value:'金属制品业'},
    {label:'通用设备制造业',value:'通用设备制造业'},
    {label:'专用设备制造业',value:'专用设备制造业'},
    {label:'交通运输设备制造业',value:'交通运输设备制造业'},
    {label:'电气机械及器材制造业',value:'电气机械及器材制造业'},
    {label:'通信设备、计算机及其他电子设备制造业',value:'通信设备、计算机及其他电子设备制造业'},
    {label:'仪器仪表及文化、办公用机械制造业',value:'仪器仪表及文化、办公用机械制造业'},
    {label:'工艺品及其他制造业',value:'工艺品及其他制造业'},
    {label:'废弃资源和废旧材料回收加工业',value:'废弃资源和废旧材料回收加工业'},
    {label:'电力、燃气及水的生产和供应业',value:'电力、燃气及水的生产和供应业'},
    {label:'电力、热力的生产和供应业',value:'电力、热力的生产和供应业'},
    {label:'燃气生产和供应业',value:'燃气生产和供应业'},
    {label:'水的生产和供应业',value:'水的生产和供应业'},
    {label:'建筑业',value:'建筑业'},
    {label:'房屋和土木工程建筑业',value:'房屋和土木工程建筑业'},
    {label:'建筑安装业',value:'建筑安装业'},
    {label:'建筑装饰业',value:'建筑装饰业'},
    {label:'其他建筑业',value:'其他建筑业'},
    {label:'交通运输、仓储和邮政业',value:'交通运输、仓储和邮政业'},
    {label:'铁路运输业',value:'铁路运输业'},
    {label:'道路运输业',value:'道路运输业'},
    {label:'城市公共交通业',value:'城市公共交通业'},
    {label:'水上运输业',value:'水上运输业'},
    {label:'航空运输业',value:'航空运输业'},
    {label:'管道运输业',value:'管道运输业'},
    {label:'装卸搬运和其他运输服务业',value:'装卸搬运和其他运输服务业'},
    {label:'仓储业',value:'仓储业'},
    {label:'邮政业',value:'邮政业'},
    {label:'信息传输、计算机服务和软件业',value:'信息传输、计算机服务和软件业'},
    {label:'电信和其他信息传输服务业',value:'电信和其他信息传输服务业'},
    {label:'计算机服务业',value:'计算机服务业'},
    {label:'软件业',value:'软件业'},
    {label:'批发和零售业',value:'批发和零售业'},
    {label:'批发业',value:'批发业'},
    {label:'零售业',value:'零售业'},
    {label:'住宿和餐饮业',value:'住宿和餐饮业'},
    {label:'住宿业',value:'住宿业'},
    {label:'餐饮业',value:'餐饮业'},
    {label:'金融业',value:'金融业'},
    {label:'银行业',value:'银行业'},
    {label:'证券业',value:'证券业'},
    {label:'保险业',value:'保险业'},
    {label:'其他金融活动',value:'其他金融活动'},
    {label:'房地产业',value:'房地产业'},
    {label:'房地产业',value:'房地产业'},
    {label:'租赁和商务服务业',value:'租赁和商务服务业'},
    {label:'租赁业',value:'租赁业'},
    {label:'商务服务业',value:'商务服务业'},
    {label:'科学研究、技术服务和地质勘查业',value:'科学研究、技术服务和地质勘查业'},
    {label:'研究与试验发展',value:'研究与试验发展'},
    {label:'专业技术服务业',value:'专业技术服务业'},
    {label:'科技交流和推广服务业',value:'科技交流和推广服务业'},
    {label:'地质勘查业',value:'地质勘查业'},
    {label:'水利、环境和公共设施管理业',value:'水利、环境和公共设施管理业'},
    {label:'水利管理业',value:'水利管理业'},
    {label:'环境管理业',value:'环境管理业'},
    {label:'公共设施管理业',value:'公共设施管理业'},
    {label:'居民服务和其他服务业',value:'居民服务和其他服务业'},
    {label:'居民服务业',value:'居民服务业'},
    {label:'其他服务业',value:'其他服务业'},
    {label:'教育',value:'教育'},
    {label:'教育',value:'教育'},
    {label:'卫生、社会保障和社会福利业',value:'卫生、社会保障和社会福利业'},
    {label:'卫生',value:'卫生'},
    {label:'社会保障业',value:'社会保障业'},
    {label:'社会福利业',value:'社会福利业'},
    {label:'文化、体育和娱乐业',value:'文化、体育和娱乐业'},
    {label:'新闻出版业',value:'新闻出版业'},
    {label:'广播、电视、电影和音像业',value:'广播、电视、电影和音像业'},
    {label:'文化艺术业',value:'文化艺术业'},
    {label:'体育',value:'体育'},
    {label:'娱乐业',value:'娱乐业'},
    {label:'公共管理和社会组织',value:'公共管理和社会组织'},
    {label:'中国共产党机关',value:'中国共产党机关'},
    {label:'国家机构',value:'国家机构'},
    {label:'人民政协和民主党派',value:'人民政协和民主党派'},
    {label:'群众团体、社会团体和宗教组织',value:'群众团体、社会团体和宗教组织'},
    {label:'基层群众自治组织',value:'基层群众自治组织'},
    {label:'国际组织',value:'国际组织'},
    {label:'国际组织',value:'国际组织'},
    {label:'其他行业',value:'其他行业'},
    {label:'未填写',value:'未填写'},
  ],
  // 单位类型
  danweileixing:[
    {label:'企业',value:'企业'},
    {label:'机关',value:'机关'},
    {label:'事业单位',value:'事业单位'},
    {label:'全额拨款事业单位',value:'全额拨款事业单位'},
    {label:'差额拨款事业单位',value:'差额拨款事业单位'},
    {label:'自收自支事业单位',value:'自收自支事业单位'},
    {label:'社会团体',value:'社会团体'},
    {label:'个体工商户(有雇工的)',value:'个体工商户(有雇工的)'},
    {label:'律师事务所',value:'律师事务所'},
    {label:'会计师事务所',value:'会计师事务所'},
    {label:'民办非企业单位',value:'民办非企业单位'},
    {label:'基金会',value:'基金会'},
    {label:'境外非政府组织驻华代表机构',value:'境外非政府组织驻华代表机构'},
    {label:'其他',value:'其他'},
  ],
  // 经济类型
  jingjileixing:[
    {label:'内资',value:'内资'},
    {label:'国有全资',value:'国有全资'},
    {label:'集体全资',value:'集体全资'},
    {label:'股份合作',value:'股份合作'},
    {label:'联营',value:'联营'},
    {label:'国有联营',value:'国有联营'},
    {label:'集体联营',value:'集体联营'},
    {label:'国有与集体联营',value:'国有与集体联营'},
    {label:'其他联营',value:'其他联营'},
    {label:'有限责任(公司)',value:'有限责任(公司)'},
    {label:'国有独资(公司)',value:'国有独资(公司)'},
    {label:'其他有限责任(公司)',value:'其他有限责任(公司)'},
    {label:'股份有限(公司)',value:'股份有限(公司)'},
    {label:'私有',value:'私有'},
    {label:'私有独资',value:'私有独资'},
    {label:'私有合伙',value:'私有合伙'},
    {label:'私营有限责任(公司)',value:'私营有限责任(公司)'},
    {label:'私营股份有限(公司)',value:'私营股份有限(公司)'},
    {label:'个体经营',value:'个体经营'},
    {label:'其他私有',value:'其他私有'},
    {label:'其他内资',value:'其他内资'},
    {label:'港、澳、台投资',value:'港、澳、台投资'},
    {label:'内地和港、澳、台合资',value:'内地和港、澳、台合资'},
    {label:'内地和港、澳、台合作',value:'内地和港、澳、台合作'},
    {label:'港、澳、台独资',value:'港、澳、台独资'},
    {label:'港、澳、台投资股份有限(公司)',value:'港、澳、台投资股份有限(公司)'},
    {label:'其他港、澳、台投资',value:'其他港、澳、台投资'},
    {label:'国外投资',value:'国外投资'},
    {label:'中外合资',value:'中外合资'},
    {label:'中外合作',value:'中外合作'},
    {label:'外资',value:'外资'},
    {label:'国外投资股份有限(公司)',value:'国外投资股份有限(公司)'},
    {label:'其他国外投资',value:'其他国外投资'},
    {label:'其他',value:'其他'},
    {label:'未填写',value:'未填写'},
  ],
  // 人员规模
  renyuanguimo:[
    {label:'3000人以上',value:'3000人以上'},
    {label:'1000--2999人',value:'1000--2999人'},
    {label:'500--999人',value:'500--999人'},
    {label:'100--499人',value:'100--499人'},
    {label:'10--99人',value:'10--99人'},
    {label:'10人以下',value:'10人以下'},
    {label:'其他',value:'其他'},
    {label:'未填写',value:'未填写'},
  ],
  // 系人即时通讯类型
  tongxunleixing:[
    {label:'QQ',value:'QQ'},
    {label:'MSN',value:'MSN'},
    {label:'其他',value:'其他'},
  ],
  // 机构状态
  jigouzhuangtai:[
    {label:'停用',value:'停用'},
    {label:'正常',value:'正常'},
  ],
  // 有效性
  youxiaoxing:[
    {label:'无效',value:'无效'},
    {label:'有效',value:'有效'},
  ],
  // areaMap
  diqu:[
    {label:'郴州市',value:'郴州市'},
    {label:'郴州市市本级',value:'郴州市市本级'},
    {label:'北湖区',value:'北湖区'},
    {label:'苏仙区',value:'苏仙区'},
    {label:'桂阳',value:'桂阳'},
    {label:'宜章县',value:'宜章县'},
    {label:'永兴县',value:'永兴县'},
    {label:'嘉禾县',value:'嘉禾县'},
    {label:'临武',value:'临武'},
    {label:'汝城县',value:'汝城县'},
    {label:'桂东县',value:'桂东县'},
    {label:'安仁县',value:'安仁县'},
    {label:'资兴市',value:'资兴市'},
  ],
}